<template>
  <div>
    <format-perso ref="formatPersoModal" @edit="handleEdit" @add="handleAdd" />
    <div id="tableau" ref="spreadsheet">
      <div class="title-and-search" ref="titleAndSearch">
        <div class="row">
          <div class="blocheader-wrapper single-title-wrapper col-12">
            <div class="row">
              <div class="button-box col-12 clear-side-padding">
                <toolBar
                        v-if="isEditable"
                        :currentCell="currentCell"
                        @setStyle="handleSetStyle"
                        @removeStyle="handleRemoveStyle"
                        @save="handleSave"
                        @export="handleExport"
                        @undo="handleUndo"
                        @redo="handleRedo"
                        @exportDescription="handleExportDescription"
                        @createSet="handleCreateSet"
                        @removeFromSet="handleRemoveFromSet"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="modal-wrapper">
      <!-- filter listing modal -->
      <b-modal
              id="filterAndListingModal"
              ref="filterAndListingModal"
              title="Dupliquer"
              :modal-class="'base-modal'"
              size="lg"
              cancel-title="Annuler"
              :no-close-on-backdrop="true"
              :no-close-on-esc="true"
              ok-title="Dupliquer"
              cancel-variant="outline-primary"
              @ok="handleAddEspace"
              @close="handleClose"
              @cancel="handleClose"
              @hide="handleClose"
      >
        <div class="row">
          <div class="col-4 px-0 zi-10">
            <filter-and-listing
                    :list="projectsListing"
                    type="projet"
                    titre="Tous les projets"
            ></filter-and-listing>
          </div>
          <div class="col-4 px-0 zi-5">
            <filter-and-listing
                    :list="tableauxListing"
                    titre="Tous les tableaux"
                    type="tableau"
            ></filter-and-listing>
          </div>
          <div class="col-4 px-0 zi-1">
            <filter-and-listing
                    :list="espacesListing"
                    titre="Sélectionner espace à afficher"
                    type="espace"
            ></filter-and-listing>
          </div>
        </div>
      </b-modal>
      <!-- /Ajout/edition format modal -->
    </div>

    <!-- modal description element -->
    <div class="modal-wrapper">
      <!-- filter listing modal -->
      <b-modal
              id="espaceDescription"
              ref="espaceDescription"
              :no-close-on-backdrop="true"
              :no-close-on-esc="true"
              title="Commentaire d' espace"
              :modal-class="'base-modal large-modal very-large-modal'"
              cancel-title="Annuler"
              ok-title="Fermer"
              cancel-variant="outline-primary"
              @ok="handleOkSaveDescription"
              @shown="toggleReadonly"
      >
        <div>
          <ckeditor
                  :editor="editor"
                  v-model="editorData"
                  :config="config"
                  :disabled="tableauData.isViewable && (tableauData.isEditable == null || tableauData.isEditable === false)"
          ></ckeditor>
        </div>
      </b-modal>
    </div>
    <!-- modal description element -->

    <!-- modal description export -->
    <div class="modal-wrapper">
      <!-- filter listing modal -->
      <b-modal
              id="espaceDescriptionExport"
              ref="espaceDescriptionExport"
              :no-close-on-backdrop="true"
              :no-close-on-esc="true"
              title="Export description d'espace"
              :modal-class="'base-modal large-modal'"
              :hide-footer="true"
      >
        <div>
          <label for="">
            <input type="checkbox" @click="selectAll" v-model="allSelected" />
            Tout sélectionner
          </label>
          <vue-custom-scrollbar class="list-description-area" :settings="settings">
            <ul>
              <li v-for="(espace, index) in existingEspace" :key="index">
                <label for="">
                  <input
                          type="checkbox"
                          v-model="selectedEspace"
                          :value="espace.index"
                  />
                  {{
                  espace.row[codeIndex] + " : " + espace.row[denominationIndex]
                  }}
                </label>
              </li>
            </ul>
          </vue-custom-scrollbar>
        </div>
        <footer class="modal-footer">
          <button type="button" class="btn btn-outline-primary" @click="handleExportDescriptionClose ()">Annuler</button>

          <button v-if="!isDescriptionExported"  type="button" class="btn btn-primary" @click.prevent="handleOkExportDescription">Exporter</button>
          <button v-else  type="button" class="btn btn-primary" ><b-spinner small type="grow"></b-spinner> En attente...</button>
        </footer>
      </b-modal>
      <!-- /Ajout/edition format modal -->
    </div>
    <!-- modal description export -->
    <b-modal
            id="modalAddRows"
            ref="modalAddRows"
            :no-close-on-backdrop="true"
            :no-close-on-esc="true"
            title="Ajouter lignes"
            :modal-class="'base-modal'"
            cancel-title="Annuler"
            ok-title="Ajouter"
            cancel-variant="outline-primary"
            @ok="handleOkAddRows">
      <b-form-group>
        <b-form-radio-group id="radio-group-2" v-model="numberRowsToAddSelected" name="radio-sub-component">
          <b-form-radio :value="5">5</b-form-radio>
          <b-form-radio :value="10">10</b-form-radio>
          <b-form-radio :value="20">20</b-form-radio>
          <b-form-radio :value="50">50</b-form-radio>
        </b-form-radio-group>
      </b-form-group>
    </b-modal>
  </div>
</template>

<script>
import Vue from 'vue'
import jexcel from 'jexcel'
import toolBar from './toolbar'
import typeDonne from './typeDonne'
import descriptionComponent from './descriptionComponent'
import { mapActions, mapGetters } from 'vuex'
import formatPerso from './modal/formatPerso'
import filterAndListing from './filterAndListing'
import listingBlock from './listingBlock'
import { EventBus, events } from '../../eventBus'
import CKEditor from '@ckeditor/ckeditor5-vue'
import Editor from '@ckeditor/ckeditor5-build-classic'
import { MyCustomUploadAdapterPlugin } from './utilsFunction'
import '@ckeditor/ckeditor5-build-classic/build/translations/fr'
import vueCustomScrollbar from 'vue-custom-scrollbar'

export default {
  components: {
    toolBar,
    typeDonne,
    formatPerso,
    filterAndListing,
    listingBlock,
    descriptionComponent,
    ckeditor: CKEditor.component,
    vueCustomScrollbar
  },
  props: {
    typeDonnees: {
      type: Object,
      required: true
    },
    tableauData: {
      type: Object,
      required: true
    },
    userType: {
      type: String
    }
  },
  data () {
    return {
      isReadOnly: null,
      isEditable: null,
      forceUpdate: false,
      skipTableUpdate: false,
      settings: {
        maxScrollbarLength: 60
      },
      rowMapping: {},
      colAlignments: ['left', 'left', 'left'],
      timer: null,
      oldRows: null,
      newRows: null,
      preventedCell: null,
      selectionStyle: null,
      hasModification: false,
      templateId: null,
      templateSelected: false,
      option: {},
      tableauSurface: null,
      maskedRow: [],
      maskedCol: [],
      rows: null,
      freezedRow: null,
      freezedCol: null,
      allDescription: [],
      descriptionIndex: null,
      typeDonneeItems: [],
      isIncompleteFormule: false,
      isFormule: false,
      previousCell: null,
      previousCellCoord: { x: 0, y: 0 },
      coord: '',
      projectsListing: [],
      tableauxListing: [],
      espacesListing: [],
      selectedTableau: null,
      espacesFromTableau: [],
      espaceSelected: null,
      titreOnglet: '',
      selelectedCellCoord: { x: 0, y: 0 },
      lastIndex: 0,
      isSomme: false,
      selectionCoordInterval: '',
      afterEnter: false,
      commentContent: null,
      existingEspace: null,
      listEspaceForDescription: null,
      inexistingIndex: null,
      listInexistingIndexForDescription: null,
      instanceDecription: [],
      editor: Editor.ClassicEditor,
      editorData: '',
      defaultContenu: '',
      numberRowsToAddSelected: null,
      rowRankForAdd: null,
      config: {
        removePlugins: ['CKFinder', 'EasyImage'],
        extraPlugins: [MyCustomUploadAdapterPlugin],
        fontFamily: {
          options: [
            'Arial',
            'Arial Black',
            'Impact',
            'Comic Sans MS',
            'Courier New',
            'Georgia',
            'Lucida Console',
            'Lucida Sans Unicode',
            'Open Sans',
            'Palatino Linotype',
            'Tahoma',
            'Times New Roman',
            'Trebuchet MS',
            'Verdana',
            'Corbel',
            'Comic Sans MS',
            'Calibri',
            'Lucida Sans',
            'Agency FB',
            'Berlin Sans FB',
            'Book Antiqua',
            'Courier New',
            'Century',
            'Century Gothic',
            'Bell MT',
            'Franklin Gothic Book',
            'Candara',
            'Bookman Old Style',
            'Impacted',
            'Arial Narrow',
            'Gill Sans',
            'Avenir Next LT Pro'
          ]
        },
        fontColor: {
          colors: [
            {
              color: 'rgb(0, 0, 0)',
              label: 'Black'
            },
            {
              color: 'rgb(255,255,255)',
              label: 'White',
              hasBorder: true
            },
            {
              color: 'rgb(255,0,0)',
              label: 'Red'
            },
            {
              color: 'rgb(0,255,0)',
              label: 'Lime'
            },
            {
              color: 'rgb(0,0,255)',
              label: 'Blue'
            },

            {
              color: 'rgb(255,255,0)',
              label: 'Yellow'
            },
            {
              color: 'rgb(0,255,255)',
              label: 'Cyan'
            },
            {
              color: 'rgb(255,0,255)',
              label: 'Magenta'
            },
            {
              color: 'rgb(191,191,191)',
              label: 'Silver'
            },
            {
              color: 'rgb(128,128,128)',
              label: 'Gray'
            },
            {
              color: 'rgb(128,0,0)',
              label: 'Maroon'
            },
            {
              color: 'rgb(128,128,0)',
              label: 'Olive'
            },
            {
              color: 'rgb(0,128,0)',
              label: 'Green'
            },
            {
              color: 'rgb(128,0,128)',
              label: 'Purple'
            },
            {
              color: 'rgb(0,128,128)',
              label: 'Teal'
            }
          ]
        },
        image: {
          toolbar: ['imageTextAlternative', '|', 'imageStyle:alignLeft', 'imageStyle:full', 'imageStyle:alignRight', 'imageStyle:alignCenter'],
          styles: [
            'full',
            'alignLeft',
            'alignRight',
            'alignCenter'
          ],
          resizeUnit: 'px'
        }
      },
      currentEspace: null,
      selectedEspace: [],
      allSelected: false,
      isModificationDescription: false,
      startEdition: false,
      isDescriptionExported: false
    }
  },
  created () {
    window['SOMME'] = this.SOMME
    window['PERCENT'] = function (val) {
      if (typeof val === 'number') {
        return val / 100
      } else {
        throw new Error('Invalid input')
      }
    }

    // overwrite the list of valid letters to open editor
    jexcel.validLetter = function (text) {
      if (text.charCodeAt(0) === 96) {
        return true
      }
      var regex = /([\u0041-\u005A\u0061-\u007A\u00AA\u00B5\u00BA\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02C1\u02C6-\u02D1\u02E0-\u02E4\u02EC\u02EE\u0370-\u0374\u0376\u0377\u037A-\u037D\u0386\u0388-\u038A\u038C\u038E-\u03A1\u03A3-\u03F5\u03F7-\u0481\u048A-\u0527\u0531-\u0556\u0559\u0561-\u0587\u05D0-\u05EA\u05F0-\u05F2\u0620-\u064A\u066E\u066F\u0671-\u06D3\u06D5\u06E5\u06E6\u06EE\u06EF\u06FA-\u06FC\u06FF\u0710\u0712-\u072F\u074D-\u07A5\u07B1\u07CA-\u07EA\u07F4\u07F5\u07FA\u0800-\u0815\u081A\u0824\u0828\u0840-\u0858\u08A0\u08A2-\u08AC\u0904-\u0939\u093D\u0950\u0958-\u0961\u0971-\u0977\u0979-\u097F\u0985-\u098C\u098F\u0990\u0993-\u09A8\u09AA-\u09B0\u09B2\u09B6-\u09B9\u09BD\u09CE\u09DC\u09DD\u09DF-\u09E1\u09F0\u09F1\u0A05-\u0A0A\u0A0F\u0A10\u0A13-\u0A28\u0A2A-\u0A30\u0A32\u0A33\u0A35\u0A36\u0A38\u0A39\u0A59-\u0A5C\u0A5E\u0A72-\u0A74\u0A85-\u0A8D\u0A8F-\u0A91\u0A93-\u0AA8\u0AAA-\u0AB0\u0AB2\u0AB3\u0AB5-\u0AB9\u0ABD\u0AD0\u0AE0\u0AE1\u0B05-\u0B0C\u0B0F\u0B10\u0B13-\u0B28\u0B2A-\u0B30\u0B32\u0B33\u0B35-\u0B39\u0B3D\u0B5C\u0B5D\u0B5F-\u0B61\u0B71\u0B83\u0B85-\u0B8A\u0B8E-\u0B90\u0B92-\u0B95\u0B99\u0B9A\u0B9C\u0B9E\u0B9F\u0BA3\u0BA4\u0BA8-\u0BAA\u0BAE-\u0BB9\u0BD0\u0C05-\u0C0C\u0C0E-\u0C10\u0C12-\u0C28\u0C2A-\u0C33\u0C35-\u0C39\u0C3D\u0C58\u0C59\u0C60\u0C61\u0C85-\u0C8C\u0C8E-\u0C90\u0C92-\u0CA8\u0CAA-\u0CB3\u0CB5-\u0CB9\u0CBD\u0CDE\u0CE0\u0CE1\u0CF1\u0CF2\u0D05-\u0D0C\u0D0E-\u0D10\u0D12-\u0D3A\u0D3D\u0D4E\u0D60\u0D61\u0D7A-\u0D7F\u0D85-\u0D96\u0D9A-\u0DB1\u0DB3-\u0DBB\u0DBD\u0DC0-\u0DC6\u0E01-\u0E30\u0E32\u0E33\u0E40-\u0E46\u0E81\u0E82\u0E84\u0E87\u0E88\u0E8A\u0E8D\u0E94-\u0E97\u0E99-\u0E9F\u0EA1-\u0EA3\u0EA5\u0EA7\u0EAA\u0EAB\u0EAD-\u0EB0\u0EB2\u0EB3\u0EBD\u0EC0-\u0EC4\u0EC6\u0EDC-\u0EDF\u0F00\u0F40-\u0F47\u0F49-\u0F6C\u0F88-\u0F8C\u1000-\u102A\u103F\u1050-\u1055\u105A-\u105D\u1061\u1065\u1066\u106E-\u1070\u1075-\u1081\u108E\u10A0-\u10C5\u10C7\u10CD\u10D0-\u10FA\u10FC-\u1248\u124A-\u124D\u1250-\u1256\u1258\u125A-\u125D\u1260-\u1288\u128A-\u128D\u1290-\u12B0\u12B2-\u12B5\u12B8-\u12BE\u12C0\u12C2-\u12C5\u12C8-\u12D6\u12D8-\u1310\u1312-\u1315\u1318-\u135A\u1380-\u138F\u13A0-\u13F4\u1401-\u166C\u166F-\u167F\u1681-\u169A\u16A0-\u16EA\u1700-\u170C\u170E-\u1711\u1720-\u1731\u1740-\u1751\u1760-\u176C\u176E-\u1770\u1780-\u17B3\u17D7\u17DC\u1820-\u1877\u1880-\u18A8\u18AA\u18B0-\u18F5\u1900-\u191C\u1950-\u196D\u1970-\u1974\u1980-\u19AB\u19C1-\u19C7\u1A00-\u1A16\u1A20-\u1A54\u1AA7\u1B05-\u1B33\u1B45-\u1B4B\u1B83-\u1BA0\u1BAE\u1BAF\u1BBA-\u1BE5\u1C00-\u1C23\u1C4D-\u1C4F\u1C5A-\u1C7D\u1CE9-\u1CEC\u1CEE-\u1CF1\u1CF5\u1CF6\u1D00-\u1DBF\u1E00-\u1F15\u1F18-\u1F1D\u1F20-\u1F45\u1F48-\u1F4D\u1F50-\u1F57\u1F59\u1F5B\u1F5D\u1F5F-\u1F7D\u1F80-\u1FB4\u1FB6-\u1FBC\u1FBE\u1FC2-\u1FC4\u1FC6-\u1FCC\u1FD0-\u1FD3\u1FD6-\u1FDB\u1FE0-\u1FEC\u1FF2-\u1FF4\u1FF6-\u1FFC\u2071\u207F\u2090-\u209C\u2102\u2107\u210A-\u2113\u2115\u2119-\u211D\u2124\u2126\u2128\u212A-\u212D\u212F-\u2139\u213C-\u213F\u2145-\u2149\u214E\u2183\u2184\u2C00-\u2C2E\u2C30-\u2C5E\u2C60-\u2CE4\u2CEB-\u2CEE\u2CF2\u2CF3\u2D00-\u2D25\u2D27\u2D2D\u2D30-\u2D67\u2D6F\u2D80-\u2D96\u2DA0-\u2DA6\u2DA8-\u2DAE\u2DB0-\u2DB6\u2DB8-\u2DBE\u2DC0-\u2DC6\u2DC8-\u2DCE\u2DD0-\u2DD6\u2DD8-\u2DDE\u2E2F\u3005\u3006\u3031-\u3035\u303B\u303C\u3041-\u3096\u309D-\u309F\u30A1-\u30FA\u30FC-\u30FF\u3105-\u312D\u3131-\u318E\u31A0-\u31BA\u31F0-\u31FF\u3400-\u4DB5\u4E00-\u9FCC\uA000-\uA48C\uA4D0-\uA4FD\uA500-\uA60C\uA610-\uA61F\uA62A\uA62B\uA640-\uA66E\uA67F-\uA697\uA6A0-\uA6E5\uA717-\uA71F\uA722-\uA788\uA78B-\uA78E\uA790-\uA793\uA7A0-\uA7AA\uA7F8-\uA801\uA803-\uA805\uA807-\uA80A\uA80C-\uA822\uA840-\uA873\uA882-\uA8B3\uA8F2-\uA8F7\uA8FB\uA90A-\uA925\uA930-\uA946\uA960-\uA97C\uA984-\uA9B2\uA9CF\uAA00-\uAA28\uAA40-\uAA42\uAA44-\uAA4B\uAA60-\uAA76\uAA7A\uAA80-\uAAAF\uAAB1\uAAB5\uAAB6\uAAB9-\uAABD\uAAC0\uAAC2\uAADB-\uAADD\uAAE0-\uAAEA\uAAF2-\uAAF4\uAB01-\uAB06\uAB09-\uAB0E\uAB11-\uAB16\uAB20-\uAB26\uAB28-\uAB2E\uABC0-\uABE2\uAC00-\uD7A3\uD7B0-\uD7C6\uD7CB-\uD7FB\uF900-\uFA6D\uFA70-\uFAD9\uFB00-\uFB06\uFB13-\uFB17\uFB1D\uFB1F-\uFB28\uFB2A-\uFB36\uFB38-\uFB3C\uFB3E\uFB40\uFB41\uFB43\uFB44\uFB46-\uFBB1\uFBD3-\uFD3D\uFD50-\uFD8F\uFD92-\uFDC7\uFDF0-\uFDFB\uFE70-\uFE74\uFE76-\uFEFC\uFF21-\uFF3A\uFF41-\uFF5A\uFF66-\uFFBE\uFFC2-\uFFC7\uFFCA-\uFFCF\uFFD2-\uFFD7\uFFDA-\uFFDC+\-\\*\\/=0-9]+)/g
      return text.match(regex) ? 1 : 0
    }

    const { data, rows, columns, style, maskedRow, maskedCol, lastIndex, freezedRow, freezedCol, descriptions, isReadOnly, isEditable, templateId } = this.tableauData
    this.lastIndex = lastIndex
    this.templateId = templateId || null
    this.isReadOnly = isReadOnly
    this.isEditable = isEditable

    let csvFileName = this.listOnglet().find(onglet => onglet.id + '' === this.currentOnglet + '').nom

    const opt = Object.assign(
      {},
      data && { data },
      rows && { rows },
      style && { style },
      columns && { columns },
      { csvFileName }
    )
    this.option = this.initOptions(opt)
    this.maskedRow = maskedRow || []
    this.maskedCol = maskedCol || []
    this.rows = rows || []

    this.freezedRow = freezedRow
    this.freezedCol = freezedCol

    if (descriptions.length !== data.length && data.length > 1) {
      this.allDescription = [...data.map((row, indexDesc) => {
        if (descriptions.findIndex(({ index }) => parseInt(index) === indexDesc) !== -1) {
          return {
            index: indexDesc,
            description: descriptions[descriptions.findIndex(({ index }) => parseInt(index) === indexDesc)].description
          }
        } else {
          return {
            index: indexDesc,
            description: ''
          }
        }
      })]
      return false
    }

    if (data.length !== 1) {
      this.allDescription = descriptions.length === 0 ? this.createArrayDescriptionFromData(data) : descriptions
      return false
    }

    this.allDescription = this.createArrayDescriptionFromData(data)
  },
  mounted () {
    document.addEventListener('keydown', this.keyDownControlsHandler)

    document.addEventListener('click', this.handleClickDescriptionIcon)

    this.tableauSurface = jexcel(this.$refs['spreadsheet'], this.option)
    this.tableauSurface.options.columns.forEach((el, index) => {
      if (!this.getColumns()[index].key) {
        this.tableauSurface.options.columns[index].key = `H${index}`
      }
    })

    if (this.tableauData.isViewable && (this.tableauData.isEditable == null || this.tableauData.isEditable === false)) {
      this.tableauSurface.options.editable = false
    } else {
      this.tableauSurface.options.editable = true
    }

    document.addEventListener('mousemove', this.mouseMoveController)
    document.addEventListener('mouseup', this.mouseUpHandler)

    // fix all duplicated Key in columns
    this.fixDuplicate(this.getColumns().map(el => el.key))

    this.setIsCloningFormat(false)

    // default hidded line
    this.hideRows(this.tableauSurface, this.maskedRow)
    this.hideColumns(this.tableauSurface, this.maskedCol)

    const max = Math.max(...this.getColumns().map((col) => parseInt(col.key.split('H')[1])))

    if (!this.lastIndex || (this.lastIndex < max)) {
      this.lastIndex = max
    }

    if (this.freezedRow !== null) this.fixedRow(this.freezedRow)
    if (this.freezedCol !== null) this.fixedCol(this.freezedCol)

    this.typeDonneeItems = this.formatTypedeDonne(this.typeDonnees)
    this.typeDonneeItems = this.typeDonneeItems.filter(type => type.type !== 'Date')

    var numRows = this.rows.length

    for (var i = 0; i < numRows; i++) {
      if (this.rows[i] !== null) {
        this.tableauSurface.rows[i].setAttribute('height', this.rows[i].height)
      }
    }

    this.overwriteHistoryHandler()
    this.tableauSurface.updateTable()

    // initialization complete
    if (!this.getColumns()[this.denominationIndex].initialized) {
      this.getColumns()[this.denominationIndex].initialized = true
    }

    // ajout espace enregistré
    this.setDisabledAddTableau(true)
    this.setProjectsList()
    // this.updateEnsembleStyle()

    EventBus.$on(events.SELECT_PROJECT, (id, type, template = false) => {
      if (type === 'projet') {
        this.handleOnselectProjects(id, template)
        return
      }

      if (type === 'tableau') {
        this.handleOnselectTableau(id)
      }
    })

    EventBus.$on(events.SELECT_ESPACES, codeEspace => {
      this.espaceSelected = codeEspace.map(code => code.split('--')[0])
    })

    EventBus.$on(events.COPY_TABLEAU, async () => {
      try {
        this.setIsCopied(false)
        this.skipTableUpdate = true
        await this.copyTableau()
        this.skipTableUpdate = false
        this.tableauSurface.updateTable()
      } catch (e) {
        this.setMessage('Une erreur est survenue pendant la duplication.')
      } finally {
        this.$refs.filterAndListingModal.hide()
        this.setIsCopied(true)
      }
    })

    EventBus.$on(events.CHANGE_ONGLET, async () => {
      await this.handleSave()
    })

    EventBus.$on(events.SAVE_CONFIRM, this.saveConfirm)
    EventBus.$on(events.ON_DESCRIPTION_OPEN, this.handleClickDescription)

    this.setExistingEspace()

    // this.renderDescriptionAndPlaceholder()

    this.$nextTick().then(() => {
      /* let typeDonneDOM = document.getElementsByClassName('data-wrapper')

      this.tableauSurface.headers.forEach((col) => {
        col.appendChild(typeDonneDOM[0])
      }) */

      this.createTypeData()

      // add decritpion to espace
      let titreColDescription = document.createElement('div')
      titreColDescription.classList.add('titre-description')

      titreColDescription.innerHTML = ''

      this.tableauSurface.rows[0].children[0].appendChild(titreColDescription)
      this.renderDescriptionAndPlaceholder()
    })
  },
  computed: {
    ...mapGetters(['currentOnglet', 'currentProject', 'isCloningFormat', 'isSelectingColor', 'showType']),
    currentCell () {
      if (this.tableauSurface && this.tableauSurface.getHighlighted()[0]) {
        return this.tableauSurface.getHighlighted()[0].style
      }
    },
    codeIndex () {
      return this.getColumns().findIndex(col => col.key === 'H0')
    },
    denominationIndex () {
      return this.getColumns().findIndex(col => col.key === 'H1')
    },
    surfaceIndex () {
      return this.getColumns().findIndex(col => col.key === 'H2')
    },
    quantiteIndex () {
      return this.getColumns().findIndex(col => col.key === 'H3')
    },
    totalIndex () {
      return this.getColumns().findIndex(col => col.key === 'H4')
    },
    contentModif () {
      var doc = new DOMParser().parseFromString(this.editorData, 'text/html')
      return new XMLSerializer().serializeToString(doc)
    }
  },
  beforeDestroy () {
    EventBus.$off(events.SAVE_CONFIRM, this.saveConfirm)
    EventBus.$off(events.COPY_TABLEAU)
    EventBus.$off(events.CHANGE_ONGLET)
    EventBus.$off(events.ON_DESCRIPTION_OPEN, this.handleClickDescription)
    document.removeEventListener('mousemove', this.mouseMoveController)
    document.removeEventListener('click', this.handleClickDescriptionIcon)
    document.removeEventListener('mouseup', this.mouseUpHandler)
    document.removeEventListener('keydown', this.keyDownControlsHandler)
    // jexcel event listener
    jexcel.build = function () {
      document.addEventListener('keydown', jexcel.keyDownControls)
      document.addEventListener('mouseup', jexcel.mouseUpControls)
      document.addEventListener('mousedown', jexcel.mouseDownControls)
      document.addEventListener('mousemove', jexcel.mouseMoveControls)
      document.addEventListener('mouseover', jexcel.mouseOverControls)
      document.addEventListener('dblclick', jexcel.doubleClickControls)
      document.addEventListener('paste', jexcel.pasteControls)
      document.addEventListener('contextmenu', jexcel.contextMenuControls)
      document.addEventListener('touchstart', jexcel.touchStartControls)
      document.addEventListener('touchend', jexcel.touchEndControls)
      document.addEventListener('touchcancel', jexcel.touchEndControls)
      document.addEventListener('touchmove', jexcel.touchEndControls)
    }
    document.removeEventListener('keydown', jexcel.keyDownControls)
    document.removeEventListener('mouseup', jexcel.mouseUpControls)
    document.removeEventListener('mousedown', jexcel.mouseDownControls)
    document.removeEventListener('mousemove', jexcel.mouseMoveControls)
    document.removeEventListener('mouseover', jexcel.mouseOverControls)
    document.removeEventListener('dblclick', jexcel.doubleClickControls)
    document.removeEventListener('paste', jexcel.pasteControls)
    document.removeEventListener('contextmenu', jexcel.contextMenuControls)
    document.removeEventListener('touchstart', jexcel.touchStartControls)
    document.removeEventListener('touchend', jexcel.touchEndControls)
    document.removeEventListener('touchcancel', jexcel.touchEndControls)
  },
  watch: {
    isDescriptionExported (newVal, oldVal) {
      console.log('isDescription', newVal, oldVal)
    },
    contentModif (newContent) {
      if (this.defaultContenu !== newContent) {
        this.isModificationDescription = true
        return
      }
      this.isModificationDescription = false
    },
    hasModification (newVal) {
      EventBus.$emit(events.HAS_MODIFICATION, newVal)
      EventBus.$emit('editable', this.tableauSurface.options.editable)
    },
    isCloningFormat (val) {
      if (val) {
        const hasSelection = this.tableauSurface.selectedCell.length > 0
        if (hasSelection) {
          this.selectionStyle = this.getSelectionStyle(...this.tableauSurface.selectedCell)
        }
      } else {
        this.selectionStyle = [[]]
      }
    },
    isSelectingColor (val) {
      if (val) {
        if (this.tableauSurface.selectedCell.length) {
          const [x, y] = this.tableauSurface.selectedCell
          const cellName = jexcel.getColumnNameFromId([x, y])
          this.preventedCell = this.tableauSurface.getCell(cellName)
          /*
            Prevent cell modification when Colorpicker's Hex||RGBA input is focused
            The selected cell stays highlighted
          */
          this.preventedCell.classList.add('readonly')
        }
      } else {
        if (this.preventedCell && this.preventedCell.classList.contains('readonly')) {
          this.preventedCell.classList.remove('readonly')
        }
      }
    }
  },
  methods: {
    toggleReadonly () {
      if (this.tableauData.isViewable && (this.tableauData.isEditable == null || this.tableauData.isEditable === false)) {
        this.config.isReadOnly = true
      } else {
        this.config.isReadOnly = false
      }
    },
    ...mapActions(['setMessage', 'exportDescription', 'modifyDescription', 'getDescription', 'addDescription', 'exportTableau', 'setIsCopied', 'setDisabledAddTableau', 'getTableauById', 'setEspaceFromTableau', 'getTableauxListById', 'projectsListById', 'deleteTypeDonnes', 'updateTypeDonnees', 'addTypeDonnees', 'saveTableauSurfaces', 'setSaving', 'setIsCloningFormat']),
    ...mapGetters(['listOnglet', 'tableauDataById', 'userSocieteId', 'projectsList', 'tableauxList', 'espacesList', 'disabledAddTableau']),
    formatNumber (n, dp = 2) {
      let e = ''
      let s = e + n
      let l = s.length
      let b = n < 0 ? 1 : 0
      let i = s.lastIndexOf('.')
      if (i === -1) {
        dp = 0
      }
      let j = i === -1 ? l : i
      let r = e
      let d = s.substr(j + 1, dp)
      while ((j -= 3) > b) { r = ' ' + s.substr(j, 3) + r }
      return s.substr(0, j + 3) + r + (dp ? '.' + d + (d.length < dp ? ('00000').substr(0, dp - d.length) : e) : e)
    },
    createTypeData () {
      this.tableauSurface.headers.forEach((col) => {
        const indexX = parseInt(col.getAttribute('data-x'), 10)
        var wrapper = document.createElement('div')
        wrapper.classList.add('data-wrapper')

        wrapper.setAttribute('data-x', indexX)

        if (this.getColumns()[indexX].key === 'H0' || this.getColumns()[indexX].key === 'H1') {
          var blankInner = document.createElement('div')
          blankInner.classList.add('blank')

          if (indexX === 0) {
            blankInner.classList.add('firstBlank')
          }
          wrapper.appendChild(blankInner)
          col.appendChild(wrapper)
          return
        }

        const ComponentClass = Vue.extend(typeDonne)
        const instance = new ComponentClass({
          propsData: {
            menuItems: this.typeDonneeItems,
            colIndex: indexX,
            selectedType: this.getColumns()[indexX].unit ? this.getColumns()[indexX].unit : ''
          }
        })
        instance.$mount()
        instance.$on('selectType', this.handleSelectType)
        instance.$on('deleteFormat', this.handleDeleteFormat)
        instance.$on('editFormat', this.handleEditFormat)
        instance.$on('addFormat', this.handleAddFormat)
        instance.$on('togglemenu', this.handleToggleMenu)

        /* console.log( instance) */
        /* console.log( instance.$listeners) */
        wrapper.appendChild(instance.$el)
        col.appendChild(wrapper)
      })
    },
    handleOkAddRows () {
      this.insertNewRow(this.tableauSurface, this.numberRowsToAddSelected, this.rowRankForAdd, true)
      this.$refs['modalAddRows'].hide()
    },
    fixDuplicate (array) {
      const hasDuplicate = array.some((el, index) => {
        return array.indexOf(el) !== index
      })

      if (hasDuplicate) {
        const defaultCol = ['H0', 'H1', 'H2', 'H3', 'H4']
        let currentIndex = 5
        this.tableauSurface.options.columns.forEach((el, index) => {
          if (!defaultCol.includes(this.tableauSurface.options.columns[index].key)) {
            this.tableauSurface.options.columns[index].key = `H${currentIndex++}`
          }
        })
      }
    },
    async saveConfirm (currMod, next) {
      if (currMod === 'TS') {
        await this.handleSave()
        next()
      }
    },
    clone (data) {
      return JSON.parse(JSON.stringify(data))
    },
    overwriteHistoryHandler () {
      this.tableauSurface.undo = this.undo
      this.tableauSurface.redo = this.redo
      this.tableauSurface.copyData = this.copyData
      this.tableauSurface.executeFormula = this.executeFormula
      // this.tableauSurface.setHistory = this.setHistory
    },
    executeFormula (expression, x, y) {
      // Code protection
      this.tableauSurface.formulaStack++
      if (this.tableauSurface.formulaStack > 5) {
        console.error('Too many executions...')
        return 0
      }
      // Parent column identification
      const parentId = jexcel.getColumnNameFromId([x, y])
      // Convert range tokens
      const tokensUpdate = function (tokens) {
        for (var index = 0; index < tokens.length; index++) {
          let f = []
          const token = tokens[index].split(':')
          const e1 = jexcel.getIdFromColumnName(token[0], true)
          const e2 = jexcel.getIdFromColumnName(token[1], true)
          let x1, x2, y1, y2
          if (e1[0] <= e2[0]) {
            x1 = e1[0]
            x2 = e2[0]
          } else {
            x1 = e2[0]
            x2 = e1[0]
          }

          if (e1[1] <= e2[1]) {
            y1 = e1[1]
            y2 = e2[1]
          } else {
            y1 = e2[1]
            y2 = e1[1]
          }

          for (let j = y1; j <= y2; j++) {
            for (let i = x1; i <= x2; i++) {
              f.push(jexcel.getColumnNameFromId([i, j]))
            }
          }

          expression = expression.replace(tokens[index], f.join(','))
        }
      }

      let tokens = expression.match(/([A-Z]+[0-9]+)\:([A-Z]+[0-9]+)/g)
      if (tokens && tokens.length) {
        tokensUpdate(tokens)
      }

      // String
      let evalstring = ''

      // Get tokens
      tokens = expression.match(/([A-Z]+[0-9]+)/g)

      if (tokens) {
        for (let i = 0; i < tokens.length; i++) {
          // Keep chain
          if (!this.tableauSurface.formula[tokens[i]]) {
            this.tableauSurface.formula[tokens[i]] = []
          }
          // Is already in the register
          if (this.tableauSurface.formula[tokens[i]].indexOf(parentId) < 0) {
            this.tableauSurface.formula[tokens[i]].push(parentId)
          }

          // Do not calculate again
          // eslint-disable-next-line no-eval
          if (eval('typeof(' + tokens[i] + ') == "undefined"')) {
            // Coords
            const position = jexcel.getIdFromColumnName(tokens[i], 1)
            let value
            // Get value
            if (typeof (this.tableauSurface.options.data[position[1]]) !== 'undefined' && typeof (this.tableauSurface.options.data[position[1]][position[0]]) !== 'undefined') {
              value = this.tableauSurface.options.data[position[1]][position[0]]
            } else {
              value = ''
            }
            if (this.getColumns()[position[0]].unit === '%') {
              if ('' + value) {
                try {
                  value = `=PERCENT(${parseFloat(value)})`
                } catch (e) {
                  value = ''
                }
              }
            }
            // Get column data
            if (('' + value).substr(0, 1) === '=') {
              value = this.tableauSurface.executeFormula(value, position[0], position[1])
            }
            // Type!
            if (('' + value).trim() === '') {
              // Null
              evalstring += 'var ' + tokens[i] + ' = null;'
            } else {
              if (value === Number(value)) {
                // Number
                evalstring += 'var ' + tokens[i] + ' = ' + value + ';'
              } else {
                // Trying any formatted number
                let number = null
                if (number = this.tableauSurface.parseNumber(value, position[0])) {
                  // Render as number
                  evalstring += 'var ' + tokens[i] + ' = ' + number + ';'
                } else {
                  // Render as string
                  evalstring += 'var ' + tokens[i] + " = '" + value + "';"
                }
              }
            }
          }
        }
      }

      this.tableauSurface.formulaStack = 0
      // Convert formula to javascript
      let res
      try {
        // eslint-disable-next-line no-eval
        res = eval(evalstring + expression.substr(1).replace(/%/g, '/100'))
      } catch (e) {
        res = '#ERROR'
      }

      return res
    },
    copyData (o, d) {
      // Get data from all selected cells
      var data = this.tableauSurface.getData(true)

      // Selected cells
      var t0 = this.tableauSurface.selectedContainer[1]
      var t1 = this.tableauSurface.selectedContainer[3]

      // Cells
      var x1 = parseInt(o.getAttribute('data-x'))
      var y1 = parseInt(o.getAttribute('data-y'))
      var x2 = parseInt(d.getAttribute('data-x'))
      var y2 = parseInt(d.getAttribute('data-y'))

      var isReversed = this.tableauSurface.getHighlighted()[0].dataset.y > y1

      // Records
      var records = []
      var recordsChain = []
      var lineNumber = 1
      var breakControl = false

      if (isReversed) {
        lineNumber = -(parseInt(y2) - parseInt(y1) + 1)
      }

      // Copy data procedure
      var posx = 0
      var posy = 0

      for (var j = y1; j <= y2; j++) {
        if (this.tableauSurface.rows[j].style.display === 'none') {
          continue
        }

        // Controls
        if (data[posy] === undefined) {
          posy = 0
        }
        posx = 0

        // Data columns
        for (var i = x1; i <= x2; i++) {
          // Update non-readonly
          if (this.tableauSurface.records[j][i] && !this.tableauSurface.records[j][i].classList.contains('readonly') && this.tableauSurface.records[j][i].style.display !== 'none' && breakControl === false) {
            // Stop if contains value
            if (!this.tableauSurface.selection.length) {
              if (this.tableauSurface.options.data[j][i]) {
                breakControl = true
                continue
              }
            }

            // Column
            if (data[posy] === undefined) {
              posx = 0
            } else if (data[posy][posx] === undefined) {
              posx = 0
            } else {
              var value = data[posy][posx]
            }

            if (value && t0 === t1 && this.tableauSurface.options.autoIncrement === true) {
              if (this.tableauSurface.options.columns[i].type === 'text' || this.tableauSurface.options.columns[i].type === 'numeric') {
                if (('' + value).substr(0, 1) === '=') {
                  var tokens = value.match(/([A-Z]+[0-9]+)/g)
                  if (tokens) {
                    var affectedTokens = []
                    for (var index = 0; index < tokens.length; index++) {
                      var position = jexcel.getIdFromColumnName(tokens[index], 1)
                      position[1] += lineNumber
                      var token = jexcel.getColumnNameFromId([position[0], position[1]])

                      if (token !== tokens[index]) {
                        affectedTokens[tokens[index]] = token
                      }
                    }
                    // Update formula
                    if (affectedTokens) {
                      value = this.tableauSurface.updateFormula(value, affectedTokens)
                    }
                  }
                } else {
                  if (value == Number(value)) {
                    value = Number(value) + lineNumber
                  }
                }
              } else if (this.tableauSurface.options.columns[i].type === 'calendar') {
                var date = new Date(value)
                date.setDate(date.getDate() + lineNumber)
                value = date.getFullYear() + '-' + parseInt(date.getMonth() + 1) + '-' + date.getDate() + ' ' + date.getHours() + ':' + date.getMinutes() + ':00'
              }
            }

            records.push(this.tableauSurface.updateCell(i, j, value))

            // Update formulas chain
            if (('' + value).substr(0, 1) === '=') {
              recordsChain[i + ',' + j] = true
            }
          }
          posx++
        }
        posy++
        lineNumber++
      }

      // Update all formulas in the chain
      var keys = Object.keys(recordsChain)
      for (let i = 0; i < keys.length; i++) {
        var k = keys[i].split(',')
        this.tableauSurface.updateFormulaChain(k[0], k[1], records)
      }

      // Update history
      this.tableauSurface.setHistory({
        action: 'setValue',
        records: records,
        selection: this.tableauSurface.selectedCell
      })

      // Update table with custom configuration if applicable
      this.tableauSurface.updateTable()

      // On after change
      if (!this.tableauSurface.ignoreEvents) {
        if (typeof (this.tableauSurface.options.onafterchanges) === 'function') {
          this.tableauSurface.options.onafterchanges(el, records)
        }
      }
    },
    handleBeforeInsertRow (el, rowNumber, numOfRows, insertBefore) {
      this.oldRows = this.clone(this.getRows())
      return true
    },
    historyHandler (history, old = null, recent = null) {
      if (history && old && recent) {
        /* history = {
          ...history,
          oldRows: old,
          newRows: recent
        } */
        history.oldRows = old
        history.newRows = recent
      }
      this.oldRows = null
      this.newRows = null
    },
    undo () {
      // Ignore events and history
      const ignoreEvents = !!this.tableauSurface.ignoreEvents
      const ignoreHistory = !!this.tableauSurface.ignoreHistory

      this.tableauSurface.ignoreEvents = true
      this.tableauSurface.ignoreHistory = true

      // Records
      const records = []

      // Update cells
      if (this.tableauSurface.historyIndex >= 0) {
        // History
        const historyRecord = this.tableauSurface.history[this.tableauSurface.historyIndex--]

        if (historyRecord.action === 'insertRow') {
          this.allDescription.splice(parseInt(historyRecord.rowNumber), 1)
          this.allDescription = this.allDescription.map((desc, index) => { return { index: index, description: desc.description } })
          this.tableauSurface.historyProcessRow(1, historyRecord)
        } else if (historyRecord.action === 'deleteRow') {
          this.allDescription = this.addEmptyDescription(this.allDescription, historyRecord.rowNumber).map((desc, index) => { return { index: index, description: desc.description } })
          this.tableauSurface.historyProcessRow(0, historyRecord)
        } else if (historyRecord.action === 'insertColumn') {
          this.tableauSurface.historyProcessColumn(1, historyRecord)
        } else if (historyRecord.action === 'deleteColumn') {
          this.tableauSurface.historyProcessColumn(0, historyRecord)
        } else if (historyRecord.action === 'moveRow') {
          this.tableauSurface.moveRow(historyRecord.newValue, historyRecord.oldValue)
        } else if (historyRecord.action === 'moveColumn') {
          this.tableauSurface.moveColumn(historyRecord.newValue, historyRecord.oldValue)
        } else if (historyRecord.action === 'setMerge') {
          this.tableauSurface.removeMerge(historyRecord.column, historyRecord.data)
        } else if (historyRecord.action === 'setStyle') {
          this.tableauSurface.setStyle(historyRecord.oldValue, null, null, 1)
        } else if (historyRecord.action === 'setWidth') {
          this.tableauSurface.setWidth(historyRecord.column, historyRecord.oldValue)
        } else if (historyRecord.action === 'setHeight') {
          this.tableauSurface.setHeight(historyRecord.row, historyRecord.oldValue)
        } else if (historyRecord.action === 'setHeader') {
          this.tableauSurface.setHeader(historyRecord.column, historyRecord.oldValue)
        } else if (historyRecord.action === 'setComments') {
          this.tableauSurface.setComments(historyRecord.column, historyRecord.oldValue[0], historyRecord.oldValue[1])
        } else if (historyRecord.action === 'orderBy') {
          var rows = []
          for (let j = 0; j < historyRecord.rows.length; j++) {
            rows[historyRecord.rows[j]] = j
          }
          this.tableauSurface.updateOrderArrow(historyRecord.column, historyRecord.order ? 0 : 1)
          this.tableauSurface.updateOrder(rows)
        } else if (historyRecord.action === 'setValue') {
          // Redo for changes in cells
          for (let i = 0; i < historyRecord.records.length; i++) {
            this.tableauSurface.updateCell(historyRecord.records[i].col, historyRecord.records[i].row, historyRecord.records[i].oldValue)
            this.tableauSurface.updateFormulaChain(historyRecord.records[i].col, historyRecord.records[i].row, records)
            if (historyRecord.oldStyle) {
              this.tableauSurface.resetStyle(historyRecord.oldStyle, true)
            }
          }
          // Update selection
          if (!historyRecord.selection) {
            historyRecord.selection = [historyRecord.records[0].col, historyRecord.records[0].row]
          }
          this.tableauSurface.updateSelectionFromCoords(historyRecord.selection[0], historyRecord.selection[1], historyRecord.selection[2], historyRecord.selection[3])
          // Update table
          this.tableauSurface.updateTable()
        } else if (historyRecord.action === 'resetStyle') {
          this.tableauSurface.setStyle(historyRecord.oldValue, null, null, 1)
        }

        if (historyRecord.oldRows) {
          const length = this.getRows().length
          this.getRows().splice(0, length, ...historyRecord.oldRows)
          this.updateEnsembleStyle()
          this.updateEnsembleFormula()
          this.renderDescriptionAndPlaceholder()
        }
      }

      this.tableauSurface.ignoreEvents = ignoreEvents
      this.tableauSurface.ignoreHistory = ignoreHistory
    },
    redo () {
      // Ignore events and history
      const ignoreEvents = !!this.tableauSurface.ignoreEvents
      const ignoreHistory = !!this.tableauSurface.ignoreHistory

      this.tableauSurface.ignoreEvents = true
      this.tableauSurface.ignoreHistory = true

      // Records
      const records = []

      // Update cells
      if (this.tableauSurface.historyIndex < this.tableauSurface.history.length - 1) {
        // History
        const historyRecord = this.tableauSurface.history[++this.tableauSurface.historyIndex]

        if (historyRecord.action === 'insertRow') {
          this.allDescription = this.addEmptyDescription(this.allDescription, historyRecord.rowNumber).map((desc, index) => { return { index: index, description: desc.description } })
          this.tableauSurface.historyProcessRow(0, historyRecord)
        } else if (historyRecord.action === 'deleteRow') {
          this.allDescription.splice(parseInt(historyRecord.rowNumber), 1)
          this.allDescription = this.allDescription.map((desc, index) => { return { index: index, description: desc.description } })
          this.tableauSurface.historyProcessRow(1, historyRecord)
        } else if (historyRecord.action === 'insertColumn') {
          this.tableauSurface.historyProcessColumn(0, historyRecord)
        } else if (historyRecord.action === 'deleteColumn') {
          this.tableauSurface.historyProcessColumn(1, historyRecord)
        } else if (historyRecord.action === 'moveRow') {
          this.tableauSurface.moveRow(historyRecord.oldValue, historyRecord.newValue)
        } else if (historyRecord.action === 'moveColumn') {
          this.tableauSurface.moveColumn(historyRecord.oldValue, historyRecord.newValue)
        } else if (historyRecord.action === 'setMerge') {
          this.tableauSurface.setMerge(historyRecord.column, historyRecord.colspan, historyRecord.rowspan, 1)
        } else if (historyRecord.action === 'setStyle') {
          this.tableauSurface.setStyle(historyRecord.newValue, null, null, 1)
        } else if (historyRecord.action === 'setWidth') {
          this.tableauSurface.setWidth(historyRecord.column, historyRecord.newValue)
        } else if (historyRecord.action === 'setHeight') {
          this.tableauSurface.setHeight(historyRecord.row, historyRecord.newValue)
        } else if (historyRecord.action === 'setHeader') {
          this.tableauSurface.setHeader(historyRecord.column, historyRecord.newValue)
        } else if (historyRecord.action === 'setComments') {
          this.tableauSurface.setComments(historyRecord.column, historyRecord.newValue[0], historyRecord.newValue[1])
        } else if (historyRecord.action === 'orderBy') {
          this.tableauSurface.updateOrderArrow(historyRecord.column, historyRecord.order)
          this.tableauSurface.updateOrder(historyRecord.rows)
        } else if (historyRecord.action === 'setValue') {
          // Redo for changes in cells
          for (let i = 0; i < historyRecord.records.length; i++) {
            this.tableauSurface.updateCell(historyRecord.records[i].col, historyRecord.records[i].row, historyRecord.records[i].newValue)
            this.tableauSurface.updateFormulaChain(historyRecord.records[i].col, historyRecord.records[i].row, records)
            if (historyRecord.newStyle) {
              this.tableauSurface.resetStyle(historyRecord.newStyle, true)
            }
          }

          // Update selection
          if (!historyRecord.selection) {
            historyRecord.selection = [historyRecord.records[0].col, historyRecord.records[0].row]
          }
          this.tableauSurface.updateSelectionFromCoords(historyRecord.selection[0], historyRecord.selection[1], historyRecord.selection[2], historyRecord.selection[3])
          // Update table
          this.tableauSurface.updateTable()
        } else if (historyRecord.action === 'resetStyle') {
          this.tableauSurface.resetStyle(historyRecord.newValue, 1)
        }

        if (historyRecord.newRows) {
          const length = this.getRows().length
          this.getRows().splice(0, length, ...historyRecord.newRows)
          this.updateEnsembleStyle()
          this.updateEnsembleFormula()
          this.renderDescriptionAndPlaceholder()
        }
      }
      this.tableauSurface.ignoreEvents = ignoreEvents
      this.tableauSurface.ignoreHistory = ignoreHistory
    },
    generateId () {
      let ID = () => Math.floor((1 + Math.random()) * 0x10000)
        .toString(16)
        .substring(1)
      return ID()
    },
    insertNewRow (instance, rowNb, rowIndex, insertBefore, skipDesc = false, isEnsemble = false) {
      instance.insertRow(rowNb, parseInt(rowIndex), insertBefore)
      this.allDescription = this.addEmptyDescription(this.allDescription, rowIndex).map((desc, index) => { return { index: index, description: desc.description } })
      // instance.getData().splice(rowIndex, 0, this.createEmptyRow())
      const rowData = this.getRows().slice(rowIndex)
      this.getRows().splice(+rowIndex + 1, rowData.length, ...rowData)
      this.getRows()[rowIndex] = null
      if (!isEnsemble) {
        const cellName = jexcel.getColumnNameFromId([this.denominationIndex, rowIndex])
        this.tableauSurface.setStyle({[cellName]: 'text-align: left;'})
        this.addToSetHandler(rowIndex)
      }
      if (!skipDesc) {
        this.renderDescriptionAndPlaceholder()
      }
    },
    handleRemoveFromSet () {
      const rows = this.tableauSurface.getSelectedRows(true)
      if (!rows.length) {
        return
      }
      this.oldRows = this.clone(this.getRows())

      rows.forEach(row => {
        const rowModel = this.getRows()[row]
        if (rowModel && rowModel.type && rowModel.type === 'espace') {
          if (rowModel.parent) {
            const parent = this.findRowById(rowModel.parent)
            parent.children = parent.children.filter(chdid => chdid !== rowModel.id)
            rowModel.level = 0
            rowModel.parent = null
          }
        }
      })

      this.newRows = this.clone(this.getRows())

      this.tableauSurface.setHistory({
        action: 'removeFromSet'
      })
      this.historyHandler(this.tableauSurface.history[this.tableauSurface.historyIndex], this.oldRows, this.newRows)

      this.tableauSurface.ignoreHistory = true
      this.updateEnsembleStyle()
      this.updateEnsembleFormula()
      this.tableauSurface.ignoreHistory = false
    },
    handleCreateSet () {
      const _this = this
      function traverse (y1, y2, callback) {
        if (Array.isArray(y1)) { // called when array id is used
          y1.forEach(id => {
            let row = _this.getRows().findIndex(el => {
              if (el) {
                return el.id === id
              }
            })
            callback(row)
          })
          return
        }
        if (y2 == null) {
          y2 = y1
        }
        const rowLengthDiff = Math.abs(y2 - y1)
        const startRow = +y2 < +y1 ? y2 : y1

        for (let row = startRow, i = 0; i <= rowLengthDiff; row++, i++) {
          callback(row)
        }
      }

      function getSelectionRoot (y1, y2) { // the one with the least level
        let root
        let ignoredEspaces = []
        traverse(y1, y2, (row) => {
          if (_this.getRows()[row]) {
            if (_this.getRows()[row].type === 'ensemble') {
              ignoredEspaces = [...ignoredEspaces, ..._this.getRows()[row].children]
            }
            if (!isNaN(_this.getRows()[row].level)) {
              if (!root || root.level > _this.getRows()[row].level) {
                root = _this.getRows()[row]
              }
            }
          }
        })
        if (root) {
          return {
            level: root.level,
            parentId: root.parent,
            ignoredEspaces
          }
        }
        return {
          level: 0,
          parentId: null,
          ignoredEspaces
        }
      }

      function updateSelectionInfo (y1, y2, parentLevel, parentId, ignoredEspaces = null) {
        let directChildren = []
        traverse(y1, y2, (row) => {
          if (!ignoredEspaces || !ignoredEspaces.includes(_this.getRows()[row] ? _this.getRows()[row].id : null)) {
            const id = _this.generateId()
            _this.getRows()[row] = {
              ..._this.getRows()[row],
              id: (_this.getRows()[row] && _this.getRows()[row].id) ? _this.getRows()[row].id : id,
              type: (_this.getRows()[row] && _this.getRows()[row].type) ? _this.getRows()[row].type : 'espace',
              level: (_this.getRows()[row] && _this.getRows()[row].level) ? _this.getRows()[row].level + 1 : parentLevel + 1
            }
            if (_this.getRows()[row].level === (parentLevel + 1)) {
              _this.getRows()[row].parent = parentId
              directChildren.push(_this.getRows()[row].id)
            }
            if (_this.getRows()[row].type === 'ensemble') {
              updateSelectionInfo(
                _this.getRows()[row].children,
                null,
                _this.getRows()[row].level,
                _this.getRows()[row].id
              )
            }
          }
        })
        if (parentId) {
          const parent = _this.findRowById(parentId)
          parent.children = [...directChildren]
          if (parent.parent) {
            const ancestor = _this.findRowById(parent.parent)
            ancestor.children = ancestor.children.filter(id => {
              return !parent.children.includes(id)
            })
            ancestor.children.push(parent.id)
          }
        }
      }
      if (this.tableauSurface.selectedCell) {
        this.skipTableUpdate = true
        let [, y, , y2] = this.tableauSurface.selectedCell

        if (parseInt(y2) < parseInt(y)) {
          const temp = y
          y = y2
          y2 = temp
        }

        const {level, parentId, ignoredEspaces} = getSelectionRoot(y, y2)
        const old = this.clone(this.getRows())
        this.oldRows = this.clone(old)
        this.insertNewRow(this.tableauSurface, 1, y, true, false, true)
        const id = this.generateId()
        this.getRows()[y] = {
          ...this.getRows()[y],
          id,
          level: level,
          type: 'ensemble',
          parent: parentId,
          children: []
        }
        updateSelectionInfo(+y + 1, +y2 + 1, level, this.getRows()[y].id, ignoredEspaces)

        const recent = this.clone(this.getRows())

        this.tableauSurface.ignoreHistory = true
        const colName = jexcel.getColumnNameFromId([this.denominationIndex, y])
        this.tableauSurface.setValue(colName, 'Ensemble')
        this.updateEnsembleStyle()
        this.updateEnsembleFormula()
        this.tableauSurface.ignoreHistory = false
        this.skipTableUpdate = false

        this.tableauSurface.updateTable()
        this.historyHandler(this.tableauSurface.history[this.tableauSurface.historyIndex], old, recent)
      }
    },
    updateEnsembleStyle () {
      const style = this.getRows().reduce((acc, curr, index) => {
        if (curr && curr.level >= 0) {
          this.rowMapping[curr.id] = index

          const cellName = jexcel.getColumnNameFromId([this.denominationIndex, index])

          if (curr.level === 0) {
            acc[cellName] = `text-align:left; padding-left: 2px`
          } else {
            acc[cellName] = `text-align:left; padding-left: ${curr.level * 20}px`
          }
        }
        return acc
      }, {})

      console.log(style)
      this.tableauSurface.setStyle(style)
    },
    updateEnsembleFormula () {
      const ensembles = this.getRows().map((row, index) => {
        return {
          row,
          index
        }
      }).filter(el => {
        return el.row && el.row.type === 'ensemble'
      })

      ensembles.forEach(ens => {
        const formulaEl = ens.row.children.map(elId => {
          const rowIndex = this.getRows().findIndex(row => {
            if (!row || !row.id) {
              return false
            }
            return row.id === elId
          })
          if (rowIndex >= 0) {
            return jexcel.getColumnNameFromId([this.totalIndex, rowIndex])
          }
          return null
        }).filter(elm => !!elm)

        const ensColName = jexcel.getColumnNameFromId([this.totalIndex, ens.index])
        if (`${this.tableauSurface.getValue(ensColName)}` !== `=${formulaEl.join('+')}`) {
          this.tableauSurface.setValue(ensColName, `=${formulaEl.join('+')}`)
        }
      })
    },
    updateRowModel (y1, y2, parentLevel, parentId) {
      if (y2 == null) {
        y2 = y1
      }

      let res = []

      const rowLengthDiff = Math.abs(y2 - y1)
      const startRow = +y2 < +y1 ? y2 : y1

      for (let row = startRow, i = 0; i <= rowLengthDiff; row++, i++) {
        const id = this.generateId()
        this.getRows()[row] = {
          ...this.getRows()[row],
          id: (this.getRows()[row] && this.getRows()[row].id) ? this.getRows()[row].id : id,
          level: parentLevel + 1,
          type: 'espace',
          parent: parentId
        }
        res.push(this.getRows()[row].id)
      }
      return res
    },
    getSelectionStyle (x1, y1, x2, y2) {
      if (x2 == null) {
        x2 = x1
      }

      if (y2 == null) {
        y2 = y1
      }

      let selectionStyle = []

      const colLengthDiff = Math.abs(x2 - x1)
      const rowLengthDiff = Math.abs(y2 - y1)

      const startCol = +x2 < +x1 ? x2 : x1
      const startRow = +y2 < +y1 ? y2 : y1

      for (let row = startRow, i = 0; i <= rowLengthDiff; row++, i++) {
        for (let col = startCol, j = 0; j <= colLengthDiff; col++, j++) {
          let cellName = jexcel.getColumnNameFromId([col, row])
          if (!selectionStyle[i]) {
            selectionStyle[i] = []
          }
          selectionStyle[i][j] = this.tableauSurface.getStyle(cellName)
        }
      }
      return selectionStyle
    },
    renderDescriptionAndPlaceholder () {
      this.allDescription.forEach(espace => {
        if (parseInt(espace.index) === 0 || (this.tableauSurface && !this.tableauSurface.rows[espace.index])) return

        if (this.tableauSurface.getData()[espace.index] && this.tableauSurface.getData()[espace.index][this.codeIndex] !== '') {
          if (this.tableauSurface.rows[espace.index].children[0].children[0]) {
            this.tableauSurface.rows[espace.index].children[0].children[0].remove()
          }

          if (espace.description !== '' && espace.description !== '<html xmlns="http://www.w3.org/1999/xhtml"><head></head><body></body></html>') {
            this.tableauSurface.rows[espace.index].children[0].appendChild(this.createDescription(espace.index, 'desc-full'))
            return
          }
          this.tableauSurface.rows[espace.index].children[0].appendChild(this.createDescription(espace.index, 'desc-empty'))
          return
        }
        this.handleCreateSubstituteSpan(this.tableauSurface.rows[espace.index].children[0])
      })
    },
    handleClickDescriptionIcon (e) {
      if (e.target.matches('.description-cta')) {
        this.descriptionIndex = parseInt(e.target.parentNode.parentNode.dataset.index)
        this.editorData = this.allDescription[this.descriptionIndex].description
        this.$refs['espaceDescription'].show()
        return
      }

      if (e.target.matches('.desc-empty') || e.target.matches('.desc-full')) {
        this.descriptionIndex = parseInt(e.target.parentNode.dataset.index)
        this.editorData = this.allDescription[this.descriptionIndex].description
        this.$refs['espaceDescription'].show()
        return
      }

      if (e.target.matches('.description-element')) {
        this.descriptionIndex = parseInt(e.target.dataset.index)
        this.editorData = this.allDescription[this.descriptionIndex].description
        this.$refs['espaceDescription'].show()
      }
    },
    createArrayDescriptionFromData (data) {
      if (data.length !== 1) {
        return data.map((row, index) => {
          return {
            index: index,
            description: ''
          }
        })
      }

      let desc = new Array(200).fill('')
      return desc.map((val, index) => {
        return {
          index: index,
          description: ''
        }
      })
    },
    createDescription (index, type) {
      let div = document.createElement('div')
      div.classList.add('description-element')
      div.setAttribute('data-index', index)

      div.innerHTML = `<svg aria-hidden="true" focusable="false" data-prefix="fas" data-icon="file-alt" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 384 512" class="${type} svg-inline--fa fa-file-alt fa-w-12"><path fill="currentColor" d="M224 136V0H24C10.7 0 0 10.7 0 24v464c0 13.3 10.7 24 24 24h336c13.3 0 24-10.7 24-24V160H248c-13.2 0-24-10.8-24-24zm64 236c0 6.6-5.4 12-12 12H108c-6.6 0-12-5.4-12-12v-8c0-6.6 5.4-12 12-12h168c6.6 0 12 5.4 12 12v8zm0-64c0 6.6-5.4 12-12 12H108c-6.6 0-12-5.4-12-12v-8c0-6.6 5.4-12 12-12h168c6.6 0 12 5.4 12 12v8zm0-72v8c0 6.6-5.4 12-12 12H108c-6.6 0-12-5.4-12-12v-8c0-6.6 5.4-12 12-12h168c6.6 0 12 5.4 12 12zm96-114.1v6.1H256V0h6.1c6.4 0 12.5 2.5 17 7l97.9 98c4.5 4.5 7 10.6 7 16.9z" class="description-cta"></path></svg>`

      return div
    },
    setDecriptionHeight (element, target, marge = 0) {
      let height = element.clientHeight + marge
      target.style.bottom = '-' + height + 'px'
    },
    selectAll () {
      this.selectedEspace = []

      if (!this.allSelected) {
        this.selectedEspace = [...this.existingEspace.map(espace => espace.index)]
      }
    },
    handleOkSaveDescription () {
      if (!this.hasModification) {
        this.hasModification = true
      }
      this.allDescription[this.descriptionIndex].description = this.contentModif

      this.renderDescriptionAndPlaceholder()
      this.$refs['espaceDescription'].hide()
    },
    async handleCreateDynamic (element, codeIndex) {
      var ComponentClass = Vue.extend(descriptionComponent)

      const payload = {
        onglet: this.currentOnglet,
        espace: codeIndex
      }

      let description = await this.getDescription(payload)
      description = description.data.data.description && description.data.data.description !== '' ? description.data.data.description : ''
      var instance = new ComponentClass({
        propsData: { codeIndex: codeIndex, contenu: description, etat: description !== '' }
      })

      instance.$mount()
      element.appendChild(instance.$el)
      this.instanceDecription.push({ instance: instance, codeIndex: codeIndex })
    },
    handleCreateSubstituteSpan (element) {
      let theSpan = document.createElement('span')
      theSpan.classList.add('placeholder-desc')
      element.appendChild(theSpan)
    },
    handleClickDescription (index, contenu) {
      this.editorData = contenu
      this.defaultContenu = contenu
      this.currentEspace = index
      this.$refs['espaceDescription'].show()
    },
    handleExportDescriptionClose () {
      this.$refs.espaceDescriptionExport.hide()
    },
    handleExportDescription () {
      this.$refs.espaceDescriptionExport.show()
    },
    async handleOkExportDescription () {
      this.isDescriptionExported = true
      const payload = {
        onglet: this.currentOnglet,
        data: {
          espaces: this.selectedEspace
          /* format: 'ODText' */
        }
      }
      await this.exportDescription(payload)
      this.isDescriptionExported = false
    },
    handleToggleMenu (show, i) {
      if (show) {
        this.tableauSurface.headers[i].style.zIndex = '1005'
        return
      }
      this.tableauSurface.headers[i].style.zIndex = '1004'
    },
    fixedRow (index) {
      this.freezedRow = index
      var tbody = document.getElementsByClassName('jexcel_content')[0].getElementsByTagName('tbody')[0]
      var freezeCtnr = document.createElement('div')
      // optmise of usign colgroup
      var colGroupClone = document.getElementsByClassName('jexcel')[0].getElementsByTagName('colgroup')[0].cloneNode(true)
      freezeCtnr.id = 'freezeCtnr'
      freezeCtnr.appendChild(colGroupClone)

      this.$nextTick().then(() => {
        // let heightTotal = 37
        for (let i = 0; i <= this.freezedRow; i++) {
          // this.tableauSurface.rows[i].style.top = heightTotal + 'px'
          // heightTotal = heightTotal + this.tableauSurface.rows[i].clientHeight
          freezeCtnr.appendChild(this.tableauSurface.rows[i])
        }
      })

      freezeCtnr.style.width = tbody.offsetWidth + 'px'
      freezeCtnr.style.position = 'sticky'
      freezeCtnr.style.top = '23px'
      freezeCtnr.style.zIndex = '1005'

      freezeCtnr.classList.add('freezectnr')

      tbody.prepend(freezeCtnr)
    },
    unfixedRow (index) {
      var tbody = document.getElementsByClassName('jexcel_content')[0].getElementsByTagName('tbody')[0]
      for (let i = index; i >= 0; i--) {
        tbody.prepend(this.tableauSurface.rows[i])
      }

      var freezeCtnr = document.getElementById('freezeCtnr')
      freezeCtnr.parentNode.removeChild(freezeCtnr)
    },
    fixedCol (x, obj) {
      let style = ''
      for (let i = 0; i <= parseInt(x); i++) {
        // obj.colgroup[i].style.left = this.tableauSurface.headers[i].offsetLeft + 'px'
        // obj.colgroup[i].style.position = 'sticky'
        /* obj.colgroup[i].style.zIndex = '1003'
        obj.colgroup[i].style.backgroundColor = 'red' */

        if (i === parseInt(x)) {
          console.log('miditra ato', i, x)
          style += `
            .jexcel tbody tr td:nth-child(${i + 2}) {
              background-color: #fff;
            }
            .jexcel tbody tr td:nth-child(${i + 2}),
            .jexcel thead tr td:nth-child(${i + 2}){
              overflow: initial !important;
              position: sticky;
              position: -webkit-sticky;
              z-index: 1003;
              left: ${this.tableauSurface.headers[i].offsetLeft + 'px'};
            }
            .jexcel tbody tr td:nth-child(${i + 2})::after,
            .jexcel thead tr td:nth-child(${i + 2})::after {
              content: "";
              width: 3px;
              position: absolute;
              right: 0;
              top: -1px;
              bottom: -1px;
              box-shadow: 2px 0px 3px -1px rgba(0, 0, 0, 0.75);
              z-index: -1 !important;
            }
            .jexcel thead tr td:nth-child(${i + 2}){
              z-index: 1004;
            }
          `
        } else {
          style += `
            .jexcel tbody tr td:nth-child(${i + 2}) {
              background-color: #fff;
            }
            .jexcel tbody tr td:nth-child(${i + 2}),
            .jexcel thead tr td:nth-child(${i + 2}){
              position: sticky;
              position: -webkit-sticky;
              z-index: 1003;
              left: ${this.tableauSurface.headers[i].offsetLeft + 'px'};

            }
            .jexcel thead tr td:nth-child(${i + 2}){
              z-index: 1004;
            }
          `
        }
        /* this.tableauSurface.headers[i].classList.add('freezedCol', 'header-col')
        this.tableauSurface.headers[i].style.left = this.tableauSurface.headers[i].offsetLeft + 'px'
        this.tableauSurface.headers[i].style.zIndex = '1003' */
        /* if (parseInt(x) === i) {
          this.tableauSurface.headers[i].classList.add('last-col')
        } */
        /* this.tableauSurface.rows.forEach(row => {
          row.cells[i + 1].classList.add('freezedCol')
          row.cells[i + 1].style.left = this.tableauSurface.headers[i].offsetLeft + 'px'

          if (parseInt(x) === i) {
            row.cells[i + 1].classList.add('last-col')
            row.cells[i + 1].style.overflow = 'initial'
          }
        }) */
      }
      var sheet = document.createElement('style')
      sheet.id = 'freezeStyle'
      sheet.innerHTML = style
      document.body.appendChild(sheet)
    },
    unfixedCol (x) {
      let toRemove = document.getElementById('freezeStyle')
      toRemove.parentNode.removeChild(toRemove)
      /* for (let i = 0; i <= x; i++) {
        this.tableauSurface.headers[i].classList.remove('freezedCol', 'header-col')
        this.tableauSurface.headers[i].style.left = 'auto'
        this.tableauSurface.rows.forEach(row => {
          row.cells[i + 1].classList.remove('freezedCol', 'last-col')
          row.cells[i + 1].style.left = 'auto'

          if (parseInt(x) === i) {
            row.cells[i + 1].classList.remove('last-col')
            row.cells[i + 1].style.overflow = 'overflow'
          }
        })
      } */
    },
    async handleSave () {
      const data = {
        id: this.currentOnglet,
        projet: parseInt(this.currentProject),
        rows: this.getRows(),
        columns: this.getColumns(),
        data: this.tableauSurface.getData(),
        maskedCol: this.maskedCol,
        maskedRow: this.maskedRow,
        freezedCol: this.freezedCol,
        freezedRow: this.freezedRow,
        descriptions: this.allDescription,
        style: this.tableauSurface.getStyle(),
        etat: 1,
        lastIndex: this.lastIndex,
        templateId: this.templateId,
        formulaValue: this.getFormulaValue()
      }
      this.setSaving(true)
      const res = await this.saveTableauSurfaces(data)
      this.hasModification = false
      this.setMessage(res)
      // this.$toaster.success(res, 3000)
      this.setSaving(false)
    },
    SOMME () {
      var result = 0
      var argsKeys = Object.keys(arguments)
      for (var i = 0; i < argsKeys.length; ++i) {
        var elt = arguments[argsKeys[i]]
        if (typeof elt === 'number') {
          result += elt
        }
      }
      return result
    },
    getFormulaValue () {
      let formulas = []

      for (let key in this.tableauSurface.formula) {
        formulas = [...new Set([...formulas, ...this.tableauSurface.formula[key]])]
      }
      const formulaResults = formulas
        .map(el => {
          const coord = jexcel.getIdFromColumnName(el, true)
          const value = this.tableauSurface.getData()[coord[1]][coord[0]]
          let result = value
          if ('' + value.startsWith('=')) {
            result = Math.round(this.tableauSurface.executeFormula(value, coord[0], coord[1])) || 0
          }
          return {
            colName: el,
            value: result
          }
        }).reduce((acc, curr) => {
          acc[`${curr.colName}`] = curr.value
          return acc
        }, {})

      return formulaResults
    },
    initOptions (attrs) {
      return Object.assign({}, {
        data: [[]],
        minDimensions: [77, 200],
        columnResize: true,
        rowResize: true,
        allowRanameColumn: false,
        tableOverFlow: true,
        fullScreen: true,
        defaultColWidth: 105,
        colAlignments: ['left'],
        contextMenu: this.contextMenuHandler,
        onfocus: this.handleOnFocus,
        oneditionstart: this.handleEditionStart,
        oneditionend: this.handleEditionEnd,
        onselection: this.handleSelection,
        oninsertcolumn: this.handleCreateCol,
        oninsertrow: this.handleCreateRow,
        onmoverow: this.handleMoveRow,
        onbeforechange: this._beforeChange,
        onbeforedeleterow: this.handleBeforeDeleteRow,
        onbeforeinsertrow: this.handleBeforeInsertRow,
        ondeleterow: this.handleDeleteRow,
        onresizerow: this.handleRowResize,
        onchangestyle: this.onchangestyle,
        onchange: this._change,
        columnDrag: true,
        columnSorting: false,
        rowDrag: true,
        onpaste: this.handlePaste,
        text: {
          hideRow: 'Masquer ligne(s)',
          showRow: 'Demasquer ligne(s)',
          showColumn: 'Demasquer colonne(s)',
          hideColumn: 'Masquer colonne(s)',
          copy: 'Copier',
          paste: 'Coller',
          insertRow: 'Ajouter ligne',
          insertColumn: 'Ajouter colonne',
          deleteSelectedRows: 'Supprimer ligne(s)',
          deleteSelectedColumns: 'Supprimer colonne(s)',
          addEspace: 'Dupliquer',
          freezeRow: 'Figer ligne(s)',
          unfreezeRow: 'Défiger ligne(s)',
          freezeCol: 'Figer colonne(s)',
          unfreezeCol: 'Defiger colonne(s)'
        },
        updateTable: (instance, cell, col, row, val, label, cellName) => {
          if (row === 0) { // ligne 0 style a modifier
            if (this.tableauSurface && !cell.style.zIndex) {
              cell.style.backgroundColor = cell.style.backgroundColor ? cell.style.backgroundColor : '#d2d3e5'
              cell.style.borderBottom = cell.style.borderBottom ? cell.style.borderBottom : '0.0625rem solid #2b3085'
              cell.style.borderRight = cell.style.borderRight ? cell.style.borderRight : '0.0625rem solid #fff'
              cell.style.fontFamily = cell.style.fontFamily ? cell.style.fontFamily : 'Arial, Helvetica, sans-serif'
              cell.style.fontWeight = cell.style.fontWeight ? cell.style.fontWeight : 'normal'
              cell.style.fontStyle = cell.style.fontStyle ? cell.style.fontStyle : 'normal'
              cell.style.fontSize = cell.style.fontSize ? cell.style.fontSize : '14px'
              cell.style.color = cell.style.color ? cell.style.color : '#2b3085'
              cell.style.height = cell.style.height ? cell.style.height : '28px'
              cell.style.zIndex = 'auto'
              cell.style.textAlign = cell.style.textAlign ? cell.style.textAlign : 'left'
            }
          }
          if (this.tableauSurface && row > 0) {
            if (this.getColumns()[col].key === 'H1' && !this.getColumns()[col].initialized) {
              if (!this.getRows()[row] || !this.getRows()[row].type) {
                cell.style.textAlign = 'left'
                cell.style.paddingLeft = '2px'
              }
            }
            if (val && !this.skipTableUpdate) {
              let content = ''
              if (`${val}`.startsWith('=')) {
                if (`${val}`.includes('SOMME') || `${val}`.includes('SUM')) {
                  content = this.tableauSurface.executeFormula(val, col, row)
                } else {
                  try {
                    if (this.forceUpdate) {
                      content = Math.round(this.tableauSurface.executeFormula(val, col, row))
                    } else {
                      content = Math.round(parseFloat(label))
                    }
                    if (isNaN(content)) {
                      throw new Error('Not a number result')
                    }
                  } catch (e) {
                    content = '0'
                  }
                }
              } else {
                content = val
              }

              if (this.getColumns()[col].unit) {
                if (['$', '£', '€'].includes(this.getColumns()[col].unit) && !this.getColumns()[col].displayFormat) {
                  this.getColumns()[col].displayFormat = 'money'
                }
                if (content) {
                  if (this.getColumns()[col].displayFormat === 'money') {
                    content = `${this.formatNumber(content)} ${this.getColumns()[col].unit || ''}`
                  } else {
                    content = `${content} ${this.getColumns()[col].unit || ''}`
                  }
                }
              }

              if (content !== label) {
                cell.innerHTML = content
              }
            }
          }
        }
      },
      attrs
      )
    },
    handleCreateRow () {
      this.newRows = this.clone(this.getRows())
      this.historyHandler(this.tableauSurface.history[this.tableauSurface.historyIndex], this.oldRows, this.newRows)
      // this.tableauSurface.updateTable()
    },
    handleEditionStart () {
      // this.startEdition = true
    },
    async setProjectsList () {
      await this.projectsListById(this.userSocieteId())
      this.projectsListing = this.projectsList()
    },
    findRowById (id) {
      /* return this.getRows()
        .find(el => {
          if (!el || !el.id) {
            return false
          }
          return el.id === id
        }) */

      let res = this.getRows()
        .find(el => {
          if (!el || !el.id) {
            return false
          }
          return el.id === id
        })

      return res
    },
    handleBeforeDeleteRow (el, rowNumber, rowNb) {
      this.oldRows = this.clone(this.getRows())
      this.allDescription.splice(parseInt(rowNumber), rowNb)
      this.allDescription = this.allDescription.map((desc, index) => { return { index: index, description: desc.description } })
      for (let rowIndex = rowNumber, i = 0; i < rowNb; rowIndex++, i++) {
        const row = this.getRows()[rowIndex]
        if (!row) {
          this.getRows().splice(rowIndex, 1)
          continue
        }
        if (row.type === 'espace' && row.parent) {
          const parent = this.findRowById(row.parent)
          if (parent) {
            parent.children = parent.children.filter(chd => chd !== row.id)
          }
        } else if (row.type === 'ensemble') {
          row.children.forEach(id => {
            const child = this.findRowById(id)
            if (child) {
              child.level = row.level
              child.parent = row.parent
            }
          })
          if (row.parent) {
            const parentEns = this.findRowById(row.parent)
            if (parentEns) {
              parentEns.children.push(...row.children)
              parentEns.children = parentEns.children.filter(chd => chd !== row.id)
            }
          }
        }
        this.getRows().splice(rowIndex, 1)
      }
      return true
    },
    onchangestyle (instance, cell, style, value) {
      if (value > '11px') {
        let theRow = cell[0].getAttribute('data-y')
        let theHeight = this.tableauSurface.rows[theRow].offsetHeight
        this.tableauSurface.setHeight(theRow, theHeight)
      }
    },
    handleRowResize (instance, cell, height) {
      // this.tableauSurface.rows[cell].style.height = height + 'px'
    },
    handleDeleteRow (el) {
      this.newRows = this.clone(this.getRows())
      this.tableauSurface.ignoreHistory = true
      this.updateEnsembleStyle()
      this.updateEnsembleFormula()
      this.tableauSurface.ignoreHistory = false
      this.renderDescriptionAndPlaceholder()
      this.historyHandler(this.tableauSurface.history[this.tableauSurface.historyIndex], this.oldRows, this.newRows)
    },
    async handleOnselectProjects (idprojet, isTemplate) {
      this.tableauxListing = []
      this.templateSelected = isTemplate
      await this.getTableauxListById(idprojet)
      this.tableauxListing = this.tableauxList()
    },
    async handleOnselectTableau (idTableau) {
      this.espacesListing = []
      this.selectedTableau = idTableau
      await this.setEspaceFromTableau(idTableau)
      this.espacesListing = this.espacesList()
      this.espacesListing = this.espacesListing.map((item, index) => {
        return {
          nom: item[1] + '',
          id: item[0] + '',
          index: index,
          data: item
        }
      })
      this.espacesFromTableau = this.espacesListing
      this.$nextTick().then(() => {
        this.setDisabledAddTableau(false)
      })
    },
    _beforeChange (instance, cell, x, y, value) {
      try {
        if (y !== 0) {
          if (`${value}`.startsWith('=')) {
            return value.toUpperCase()
          }
          if (this.getColumns()[x].type === 'numeric') {
            if (value === '' || !value) {
              return ''
            }
            return parseFloat(value)
          }
          return value
        }
      } catch (e) {
        return NaN
      }
    },
    arrayMoveMutate (array, from, to) {
      const startIndex = to < 0 ? array.length + to : to
      const item = array.splice(from, 1)[0]
      array.splice(startIndex, 0, item)
    },
    arrayMove (array, from, to) {
      array = array.slice()
      this.arrayMoveMutate(array, from, to)
      return array
    },
    handleOnFocus () {
      if (!this.hasModification) {
        this.hasModification = true
      }
    },
    rearangeArray (array, destinataire) {
      return array.map((desc, index) => {
        if (index >= destinataire) {
          return {
            index,
            description: desc.description
          }
        }

        return {
          index,
          description: desc.description
        }
      })
    },
    addToSet (rowIndex, ensemble) {
      if (!this.getRows()[rowIndex] || !this.getRows()[rowIndex].id) {
        this.getRows()[rowIndex] = {
          ...this.getRows()[rowIndex],
          id: this.generateId(),
          level: ensemble.level + 1,
          type: 'espace',
          parent: ensemble.id
        }
        ensemble.children.push(this.getRows()[rowIndex].id)
      } else {
        const row = this.getRows()[rowIndex]
        if (row.parent) {
          const parent = this.findRowById(row.parent)
          parent.children = parent.children.filter(id => id !== row.id)
        }
        ensemble.children.push(row.id)
        row.parent = ensemble.id
        row.level = ensemble.level + 1
        if (!row.type) {
          row.type = 'espace'
        }
      }

      this.skipTableUpdate = true
      this.tableauSurface.ignoreHistory = true
      this.updateEnsembleStyle()
      this.updateEnsembleFormula()
      this.tableauSurface.ignoreHistory = false
      this.skipTableUpdate = false

      this.tableauSurface.updateTable()
    },
    addToEnsembleConfirmation (rowIndex, ensemble) {
      this.$bvModal.msgBoxConfirm(`Voulez-vous ajouter cette ligne à l'ensemble`, {
        modalClass: 'base-modal',
        title: 'Validation ajout',
        buttonSize: 'sm',
        okVariant: 'outline-primary',
        okTitle: 'OUI',
        cancelVariant: 'outline-info',
        cancelTitle: 'NON',
        footerClass: 'p-2',
        hideHeaderClose: true
      })
        .then(value => {
          if (value) {
            this.addToSet(rowIndex, ensemble)
          }
        })
    },
    addToSetHandler (rowIndex) {
      const predecessorIndex = rowIndex - 1
      if (predecessorIndex > 0) {
        const predecessor = this.getRows()[predecessorIndex]
        const el = this.getRows()[rowIndex]
        if (el && el.parent && el.parent === predecessor.id) {
          // do nothing
        } else if (predecessor) {
          switch (predecessor.type) {
            case 'espace':
              if (predecessor.parent) {
                const parent = this.findRowById(predecessor.parent)
                this.addToSet(rowIndex, parent)
              }
              break
            case 'ensemble':
              const parent = this.findRowById(predecessor.id)
              this.addToSet(rowIndex, parent)
              break
            default:
              break
          }
        }
      }
    },
    handleMoveRow (el, currentMooving, destinataire) {
      if (this.getRows()[currentMooving] && this.getRows()[currentMooving].type === 'ensemble') {
        this.tableauSurface.undo()
        this.renderDescriptionAndPlaceholder()
        return
      }
      this.oldRows = this.clone(this.getRows())
      this.getRows().splice(destinataire, 0, this.getRows().splice(currentMooving, 1)[0])
      this.addToSetHandler(destinataire)
      this.newRows = this.clone(this.getRows())
      this.allDescription = this.arrayMove(this.allDescription, currentMooving, destinataire)
      // this.tableauData.data = this.arrayMove(this.tableauData.data, currentMooving, destinataire)
      this.allDescription = this.rearangeArray(this.allDescription, destinataire)
      this.historyHandler(this.tableauSurface.history[this.tableauSurface.historyIndex], this.oldRows, this.newRows)
      // this.updateEnsembleFormula()
      this.renderDescriptionAndPlaceholder()
    },
    handleCreateCol (el, columnNumber, numOfColumns) {
      this.lastIndex = this.lastIndex + 1
      if (!this.getColumns()[columnNumber].key) {
        this.getColumns()[columnNumber].key = `H${this.lastIndex}`
      } else {
        this.getColumns()[columnNumber + 1].key = `H${this.lastIndex}`
      }
      this.createTypeData()
    },
    handleAddEspace () {
      const maxCol = this.getColumns().length
      const espaces = this.espacesFromTableau.filter(espace => this.espaceSelected.includes(espace.id)).map(espace => {
        return espace.data.map(dt => {
          if (typeof dt === 'string' && dt.startsWith('=')) {
            return ''
          }
          return dt
        }).slice(0, maxCol)
      })

      espaces.reverse()

      espaces.forEach((espace, index) => {
        this.insertNewRow(this.tableauSurface, espace, this.selelectedCellCoord.y, true, true)
      })

      if (!this.hasModification) {
        this.hasModification = true
      }

      this.renderDescriptionAndPlaceholder()
    },
    async copyTableau () {
      function sanitizeRows (rows) {
        if (rows) {
          return rows.map(row => {
            if (row) {
              row.fiche = null
              row.colAddedToFiche = []
            }
            return row
          })
        }
        return []
      }
      if (!this.disabledAddTableau()) {
        await this.getTableauById(this.selectedTableau)
        const colLengthDiff = this.tableauDataById().columns.length - this.getColumns().length
        if (colLengthDiff > 0) {
          this.tableauSurface.insertColumn(colLengthDiff)
        }
        if (this.templateSelected) {
          this.templateId = this.selectedTableau
        } else if (this.tableauDataById().templateId) {
          this.templateId = this.tableauDataById().templateId
        }
        this.tableauSurface.options.columns = this.tableauDataById().columns || this.tableauSurface.options.columns
        this.tableauSurface.options.rows = sanitizeRows(this.tableauDataById().rows)
        this.tableauSurface.setData(this.tableauDataById().data)
        this.tableauSurface.setStyle(this.tableauDataById().style)
        this.allDescription = this.createArrayDescriptionFromData(this.tableauDataById().data)
        this.renderDescriptionAndPlaceholder()
        this.updateEnsembleStyle()
        if (!this.getColumns()[this.denominationIndex].initialized) {
          this.getColumns()[this.denominationIndex].initialized = true
        }
        if (!this.hasModification) {
          this.hasModification = true
        }
      }
    },
    async handleExport () {
      if (this.hasModification) {
        await this.handleSave()
      }
      if (!this.exportTableau(this.currentOnglet)) {
        this.setMessage("Erreur d'export")
        // this.$toaster.error('Erreur export tableau')
      }
    },
    handleClose () {
      this.tableauxListing = []
      this.espacesListing = []
      this.setDisabledAddTableau(true)
      EventBus.$emit(events.RESET_FILTER)
    },
    getRows () {
      return this.tableauSurface.options.rows
    },
    getColumns () {
      return this.tableauSurface.options.columns
    },
    handleAddFormat () {
      this.$refs['formatPersoModal'].open({ isEdit: false })
    },
    handleEditFormat (id, type) {
      this.$refs['formatPersoModal'].open({ isEdit: true, id, value: type })
    },
    async handleAdd (value, oldValue) {
      const data = {
        unite: value,
        decimale: 0
      }
      await this.addTypeDonnees(data)
      const child = {
        type: value,
        decimale: 0,
        editable: 1
      }
      this.typeDonneeItems = this.typeDonneeItems.map(x => {
        if (x.type === 'Format personalisé') {
          x.children.push(child)
        }
        return x
      })
    },
    async handleEdit (id, value, oldValue) {
      const data = {
        unite: value,
        decimale: 0
      }
      await this.updateTypeDonnees({ id, data })
      this.typeDonneeItems = this.typeDonneeItems.map(x => {
        if (x.type === 'Format personalisé') {
          x.children.map(child => {
            if (child.type === oldValue) {
              child.type = value
            }
            return child
          })
        }

        if (x.type === oldValue) {
          x.type = value
        }
        return x
      })
    },
    handleDeleteFormat (id) {
      this.$bvModal.msgBoxConfirm(`Voulez-vous vraiment supprimer ce type de données ?`, {
        modalClass: 'base-modal ',
        title: 'Suppression de type de données',
        buttonSize: 'sm',
        headerClass: 'bg-danger',
        okVariant: 'outline-danger',
        okTitle: 'OUI',
        cancelVariant: 'outline-primary',
        cancelTitle: 'NON',
        footerClass: 'p-2',
        hideHeaderClose: true
      })
        .then(async value => {
          if (value) {
            const res = await this.deleteTypeDonnes(id)
            this.typeDonneeItems = this.typeDonneeItems.filter((item) => {
              if (item.id && item.id !== id) {
                return item
              }

              if (item.children) {
                item.children = item.children.filter(child => {
                  return child.id !== id
                })
                return item
              }
            })
            this.setMessage(res)
            // this.$toaster.info(res, { timeout: 3000 })
          }
        })
    },
    handleSelectType (colIndex, typeDonnee) {
      this.patchColumnsType(colIndex, typeDonnee)
    },
    patchColumnsType (colIndex, typeDonnee) {
      const nonNumeric = ['Texte', 'Date']
      const nonUnitType = ['Texte', 'Date', 'Nombre entier']
      if (nonNumeric.indexOf(typeDonnee.type) === -1) {
        this.tableauSurface.options.columns[colIndex].type = 'numeric'
        // this.tableauSurface.options.columns[colIndex].allowEmpty = true
      } else {
        this.tableauSurface.options.columns[colIndex].type = 'text'
      }
      if (nonUnitType.indexOf(typeDonnee.type) === -1) {
        if (['$', '£', '€'].includes(typeDonnee.unite)) {
          this.tableauSurface.options.columns[colIndex].displayFormat = 'money'
        } else {
          this.tableauSurface.options.columns[colIndex].displayFormat = 'none'
        }
        this.tableauSurface.options.columns[colIndex].unit = typeDonnee.unite ? typeDonnee.unite : typeDonnee.type
      } else {
        this.tableauSurface.options.columns[colIndex].displayFormat = 'none'
        this.tableauSurface.options.columns[colIndex].unit = ' '
      }
      this.forceUpdate = true
      this.tableauSurface.updateTable()
      this.forceUpdate = false
    },
    createEditor (cell, type) {
      // ne pas recréer l'input car ça ralentit
      if (cell.children && cell.children.length > 0) {
        return cell.children[0]
      }
      // Cell information
      let info = cell.getBoundingClientRect()

      // Create dropdown
      var editor = document.createElement(type)
      editor.style.width = (info.width) + 'px'
      editor.style.height = (info.height - 2) + 'px'
      editor.style.minHeight = (info.height - 2) + 'px'

      // Edit cell
      // cell.classList.remove('editor')
      cell.classList.add('editor')
      cell.innerHTML = ''
      cell.appendChild(editor)

      return editor
    },
    keyDownControlsHandler (e) {
      if (e.keyCode === 13) {
        if (this.isSomme) {
          e.preventDefault()
          e.stopPropagation()
          e.stopImmediatePropagation()
          this.afterEnter = true
          this.selectionCoordInterval = ''
          this.customCloseEditor(this.previousCell, false)
          return false
        } else if (this.isIncompleteFormule) {
          e.preventDefault()
          e.stopPropagation()
          this.isIncompleteFormule = false
          this.afterEnter = true
          this.customCloseEditor(this.previousCell, false)
        }
      }
    },
    setEditorOpen (cell, obj, el, empty, selectedRange, e) {
      if (!cell && this.isSomme) return

      let y = cell.getAttribute('data-y')
      let x = cell.getAttribute('data-x')

      var value = empty === true ? '' : obj.options.data[y][x]
      var editor = this.createEditor(cell, 'input')
      editor.value = value + selectedRange + ')'
    },
    customOpenEditor (cell, obj, el, empty, val) {
      let y = cell.getAttribute('data-y')
      let x = cell.getAttribute('data-x')

      // On edition start
      if (!obj.ignoreEvents) {
        if (typeof (obj.options.oneditionstart) === 'function') {
          obj.options.oneditionstart(el, cell, x, y)
        }
      }

      /* if (window.navigator.userAgent.indexOf('Firefox') > -1) {
        document.removeEventListener('keydown', jexcel.keyDownControls)
      } */

      let value

      if (!val) {
        value = empty === true ? '' : obj.options.data[y][x] + this.coord
      } else {
        value = val + this.coord
      }

      this.coord = ''

      // Basic editor
      const editor = this.createEditor(cell, 'input')
      // Mask
      if (obj.options.columns[x].mask) {
        editor.setAttribute('data-mask', obj.options.columns[x].mask)
      }
      editor.value = value
      editor.onblur = (e) => {
        if (this.isIncompleteFormule) {
          editor.onblur = null
          editor.onkeydown = null
          if (this.tableauSurface.selectedCell[0] + '' !== x + '' && this.tableauSurface.selectedCell[1] + '' !== y + '') {
            obj.edition = [obj.records[y][x], obj.records[y][x].innerHTML, x, y]
            this.customCloseEditor(cell, false)
          } else {
            obj.edition = [obj.records[y][x], obj.records[y][x].innerHTML, x, y]
            this.customOpenEditor(cell, obj, el, false, editor.value)
          }
        } else {
          obj.edition = [obj.records[y][x], obj.records[y][x].innerHTML, x, y]
          this.customCloseEditor(cell, false)
        }
      }
      editor.focus()
    },
    mouseMoveController (e) {
      if (jexcel.current) {
        if (jexcel.isMouseAction === true) {
          if (!jexcel.current.resizing) {
            this.mouseMoveHandler(e)
          }
        }
      }
    },
    mouseUpHandler (e) {
      clearTimeout(this.timer)
    },
    mouseMoveHandler (e) {
      e = e || window.event
      let mouseButton
      if (e.buttons) {
        mouseButton = e.buttons
      } else if (e.button) {
        mouseButton = e.button
      } else {
        mouseButton = e.which
      }

      if (!mouseButton) {
        jexcel.isMouseAction = false
      }

      let viewportX = event.clientX
      let viewportY = event.clientY

      const _this = this

      let viewportWidth = this.tableauSurface.content.clientWidth
      let viewportHeight = this.tableauSurface.content.clientHeight

      const {left, top, width, height} = this.tableauSurface.content.getBoundingClientRect()
      let edgeTop = top
      let edgeLeft = left + 50
      let edgeBottom = edgeTop + height
      let edgeRight = left + width

      let isInLeftEdge = (viewportX < edgeLeft)
      let isInRightEdge = (viewportX > edgeRight)
      let isInTopEdge = (viewportY < edgeTop)
      let isInBottomEdge = (viewportY > edgeBottom)

      // If the mouse is not in the viewport edge, there's no need to calculate
      // anything else.
      if (!(isInLeftEdge || isInRightEdge || isInTopEdge || isInBottomEdge)) {
        clearTimeout(this.timer)
        return
      }

      let documentWidth = Math.max(
        this.tableauSurface.content.scrollWidth,
        this.tableauSurface.content.offsetWidth,
        this.tableauSurface.content.clientWidth
      )
      let documentHeight = Math.max(
        this.tableauSurface.content.scrollHeight,
        this.tableauSurface.content.offsetHeight,
        this.tableauSurface.content.clientHeight
      )

      let maxScrollY = documentHeight - viewportHeight
      let maxScrollX = documentWidth - viewportWidth;

      (function checkForWindowScroll () {
        clearTimeout(_this.timer)

        if (adjustWindowScroll()) {
          _this.timer = setTimeout(checkForWindowScroll, 30)
        }
      })()

      function adjustWindowScroll () {
        // Get the current scroll position of the document.
        let currentScrollX = _this.tableauSurface.content.scrollLeft
        let currentScrollY = _this.tableauSurface.content.scrollTop

        // Determine if the window can be scrolled in any particular direction.
        let canScrollUp = (currentScrollY > 0)
        let canScrollDown = (currentScrollY < maxScrollY)
        let canScrollLeft = (currentScrollX > 0)
        let canScrollRight = (currentScrollX < maxScrollX)

        let nextScrollX = currentScrollX
        let nextScrollY = currentScrollY

        let maxStep = 10

        // Should we scroll left?
        if (isInLeftEdge && canScrollLeft) {
          nextScrollX = (nextScrollX - (maxStep))

          // Should we scroll right?
        } else if (isInRightEdge && canScrollRight) {
          nextScrollX = (nextScrollX + (maxStep))
        }

        // Should we scroll up?
        if (isInTopEdge && canScrollUp) {
          nextScrollY = (nextScrollY - (maxStep))

          // Should we scroll down?
        } else if (isInBottomEdge && canScrollDown) {
          nextScrollY = (nextScrollY + (maxStep))
        }

        nextScrollX = Math.max(0, Math.min(maxScrollX, nextScrollX))
        nextScrollY = Math.max(0, Math.min(maxScrollY, nextScrollY))

        if (
          (nextScrollX !== currentScrollX) || (nextScrollY !== currentScrollY)
        ) {
          _this.tableauSurface.content.scrollTo(nextScrollX, nextScrollY)
          return (true)
        } else {
          return (false)
        }
      }
    },
    customCloseEditor (cell, save) {
      let x = parseInt(cell.getAttribute('data-x'))
      let y = parseInt(cell.getAttribute('data-y'))
      let obj = this.tableauSurface

      let value = cell.children[0].value
      cell.children[0].onblur = null
      obj.setValue(cell, value)

      // Remove editor class
      cell.classList.remove('editor')

      // Finish edition
      obj.edition = null

      // On edition end
      if (!obj.ignoreEvents) {
        if (typeof (obj.options.oneditionend) === 'function') {
          obj.options.oneditionend(obj.el, cell, x, y, value)
        }
      }
    },
    handleEditionEnd (el, cell, x, y) {
      // this.startEdition = false
      if (this.getColumns()[x].key === 'H0') {
        // ajout description acces si pas de description
        const innerDesc = this.tableauSurface.rows[y].children[0].children[0]

        if ((innerDesc.classList.contains('placeholder-desc') && cell.innerText !== '') || (innerDesc.classList.contains('placeholder-desc') && cell.innerText !== '<html xmlns="http://www.w3.org/1999/xhtml"><head></head><body></body></html>')) {
          innerDesc.remove()
          if (this.allDescription[y].description !== '' && this.allDescription[y].description !== '<html xmlns="http://www.w3.org/1999/xhtml"><head></head><body></body></html>') {
            this.tableauSurface.rows[y].children[0].appendChild(this.createDescription(y, 'desc-full'))
          } else {
            this.tableauSurface.rows[y].children[0].appendChild(this.createDescription(y, 'desc-empty'))
          }
          return
        }

        // suppression description
        this.$nextTick().then(() => {
          if (this.tableauSurface.getData()[y][x] === '' || this.tableauSurface.getData()[y][x] === '<html xmlns="http://www.w3.org/1999/xhtml"><head></head><body></body></html>') {
            if (this.tableauSurface.rows[y].children[0].childElementCount >= 1) {
              if (innerDesc.classList.contains('description-element')) {
                innerDesc.remove()
              }
              this.handleCreateSubstituteSpan(this.tableauSurface.rows[y].children[0])
            }
          }
        })
      }

      this.$nextTick().then(() => {
        // test if code colomn

        /* fonction pour ajout reference cellule au click */
        this.isSomme = false

        this.selectionCoordInterval = ''
        const val = this.tableauSurface.getValue(cell)
        const regTest = /[+\-\\*\\/]+$/.test('' + val)
        // const validFormula = /[0-9]+$/.test('' + val.substring(-1))

        if (val && this.testIncompleteSomme(val)) {
          this.previousCell = cell
          this.previousCellCoord.x = x
          this.previousCellCoord.y = y
          this.isSomme = true
          return
        }
        if (val &&
                  ((val.toString().startsWith('=') && regTest) || (val.toString().substr(0, 1) === '=' && '' + val.toString().substr(1, 1) === '')) && this.tableauSurface.options.parseFormulas === true) {
          this.tableauSurface.setValue(cell, val.toUpperCase())
          this.previousCell = cell
          this.previousCellCoord.x = x
          this.previousCellCoord.y = y
          this.isIncompleteFormule = true
          this.isFormule = true
        }
      })
    },
    testIncompleteSomme (formule) {
      return /.*SOMME\($/.test('' + formule)
    },
    createRefFromCoord (x, y) {
      return this.tableauSurface.getHeader(x).split('\n')[0] + '' + parseInt(y + 1)
    },
    handleSelection (instance, x1, y1, x2, y2, origin) {
      /* function ajout reference pour somme */
      if (this.isCloningFormat) {
        const rowLength = this.selectionStyle.length
        const colLength = this.selectionStyle[0].length

        let styleSetter = {}

        for (let row = y1, i = 0; i < rowLength; row++, i++) {
          for (let col = x1, j = 0; j < colLength; col++, j++) {
            let cellName = jexcel.getColumnNameFromId([col, row])
            this.tableauSurface.resetStyle({ [cellName]: 'z-index: auto' }, true)
            styleSetter[`${cellName}`] = this.selectionStyle[i][j]
          }
        }

        this.tableauSurface.setStyle(styleSetter, true)
        this.setIsCloningFormat(false)
      }
      if (this.isSomme) {
        this.selectionCoordInterval = `${this.createRefFromCoord(x1, y1)}:${this.createRefFromCoord(x2, y2)}`
        this.setEditorOpen(this.previousCell, this.tableauSurface, instance, false, this.selectionCoordInterval)
        return
      }

      /* fonction pour ajout reference cellule au click */
      this.selelectedCellCoord.x = x1
      this.selelectedCellCoord.y = y1
      this.$nextTick().then(() => {
        if (this.isFormule) {
          this.isFormule = false
          // this.coord = this.tableauSurface.getHeader(x1).split('\n')[0] + '' + parseInt(y1 + 1)
          this.coord = this.createRefFromCoord(x1, y1)
          this.tableauSurface.updateSelectionFromCoords(this.previousCellCoord.x, this.previousCellCoord.y)
          this.customOpenEditor(this.previousCell, this.tableauSurface, instance, false)
          if (this.afterEnter === true) {
            this.afterEnter = false
          }
        }
      })

      // this.isIncompleteFormule = false
    },
    hideRows (instance, indexRows) {
      indexRows.forEach(y => {
        if (y < instance.rows.length) {
          instance.rows[y].classList.add('hideRow')
        }
      })
    },
    hideColumns (instance, indexColumns) {
      indexColumns.forEach(x => {
        if (x < instance.options.colHeaders.length) {
          instance.headers[x].classList.add('hidecol')
          instance.setWidth(x, 1)
        }
      })
    },
    handleChange (instance, cell, x, y, value) {
      this.tableauSurface.getHighlighted()
    },
    addEmptyDescription (allDescription, index) {
      allDescription.splice(index, 0, { index, description: '' })
      return allDescription
    },
    createEmptyRow () {
      return this.tableauSurface.getRowData(0).map(col => '')
    },
    contextMenuHandler (obj, x, y, e) {
      let items = []
      let hiddenRows = []
      let hiddenCols = []
      let indexElementMasqued = 0
      let indexElementColMasqued = 0

      if (y != null && x != null) {
        this.tableauSurface.updateSelectionFromCoords(x, y)
      }
      if (y != null) {
        // ajout de ligne
        if (obj.options.allowInsertRow === true && y > 0) {
          items.push({
            title: obj.options.text.insertRow,
            onclick: () => {
              this.insertNewRow(this.tableauSurface, 1, parseInt(y), true)
            }
          })
        }

        if (obj.options.allowInsertRow === true && y > 0) {
          items.push({
            title: 'Inserer plusieurs lignes',
            onclick: () => {
              this.rowRankForAdd = parseInt(y)
              this.$refs['modalAddRows'].show()
              // this.insertNewRow(this.tableauSurface, 1, parseInt(y), true)
            }
          })
        }

        // supprimer ligne(s)
        if (obj.options.allowDeleteRow === true && y > 0) {
          items.push({
            title: obj.options.text.deleteSelectedRows,
            onclick: () => {
              obj.deleteRow(obj.getSelectedRows().length ? undefined : parseInt(y))
            }
          })
        }

        // figer ligne
        if (this.freezedRow === null) {
          items.push({
            title: obj.options.text.freezeRow,
            onclick: () => {
              this.freezedRow = y
              this.fixedRow(y)
            }
          })
        }
        // defiger ligne
        if (this.freezedRow !== null) {
          items.push({
            title: obj.options.text.unfreezeRow,
            onclick: () => {
              this.unfixedRow(this.freezedRow)
              this.freezedRow = null
            }
          })
        }

        if (y > 0) {
          // masquer ligne(s)
          items.push({
            title: obj.options.text.hideRow,
            onclick: () => {
              obj.getSelectedRows().forEach(row => {
                this.maskedRow.push(parseInt(row.dataset.y))
                row.classList.add('hideRow')
              })
            }
          })

          // demasquer lignes
          hiddenRows = obj.getSelectedRows().filter(items => items.classList.contains('hideRow'))

          if (hiddenRows.length > 0) {
            items.push({
              title: obj.options.text.showRow,
              onclick: () => {
                hiddenRows.forEach((row) => {
                  indexElementMasqued = this.maskedRow.indexOf(parseInt(row.dataset.y))
                  if (indexElementMasqued > -1) {
                    this.maskedRow.splice(indexElementMasqued, 1)
                  }
                  row.classList.remove('hideRow')
                })
              }
            })
          }
        }
      }

      if (x != null) {
        // ajouter colonne(s)
        if (obj.options.allowInsertColumn === true) {
          items.push({
            title: obj.options.text.insertColumn,
            onclick: () => {
              obj.insertColumn(1, parseInt(x), 1)
            }
          })
        }

        // supprimer column
        const keyArray = ['H0', 'H1', 'H2', 'H3', 'H4']
        if (obj.options.allowDeleteColumn === true && keyArray.indexOf(this.getColumns()[x].key) === -1) {
          items.push({
            title: obj.options.text.deleteSelectedColumns,
            onclick: () => {
              obj.deleteColumn(obj.getSelectedColumns().length ? undefined : parseInt(x))
            }
          })
        }

        // masquer column(s)
        items.push({
          title: obj.options.text.hideColumn,
          onclick: () => {
            this.maskedCol = obj.getSelectedColumns()
            this.maskedCol.forEach(x => {
              obj.setWidth(x, 1)
              obj.headers[x].classList.add('hidecol')
            })
          }
        })

        // demasquer colonnes
        hiddenCols = obj.getSelectedColumns().filter(item => {
          return this.maskedCol.includes(item)
        })

        if (hiddenCols.length > 0) {
          items.push({
            title: obj.options.text.showColumn,
            onclick: () => {
              hiddenCols.forEach((col) => {
                indexElementColMasqued = this.maskedCol.indexOf(parseInt(obj.headers[col].dataset.y))
                if (indexElementColMasqued >= -1) {
                  this.maskedCol = this.maskedCol.length > 1 ? this.maskedCol.splice(indexElementColMasqued, 1) : []
                }
                obj.headers[col].classList.remove('hidecol')
                obj.setWidth(col, obj.options.defaultColWidth)
              })
            }
          })
        }

        // figer colonne
        if (this.freezedCol === null) {
          items.push({
            title: obj.options.text.freezeCol,
            onclick: () => {
              this.freezedCol = x
              this.fixedCol(this.freezedCol, obj)
            }
          })
        }

        if (this.freezedCol !== null) {
          items.push({
            title: obj.options.text.unfreezeCol,
            onclick: () => {
              this.unfixedCol(this.freezedCol)
              this.freezedCol = null
            }
          })
        }
      }

      // ajout espaces
      if (y !== null && y > 0) {
        items.push({
          title: obj.options.text.addEspace,
          onclick: () => {
            // showmodal
            this.$refs.filterAndListingModal.show()
          }
        })
      }

      // copy
      items.push({
        title: obj.options.text.copy,
        shortcut: 'Ctrl + C',
        onclick: () => {
          obj.copy(true)
        }
      })

      // Paste
      if (navigator && navigator.clipboard) {
        items.push({
          title: obj.options.text.paste,
          shortcut: 'Ctrl + V',
          onclick: () => {
            if (obj.selectedCell) {
              navigator.clipboard.readText().then(function (text) {
                if (text) {
                  jexcel.current.paste(obj.selectedCell[0], obj.selectedCell[1], text)
                }
              })
            }
          }
        })
      }

      return items
    },
    handleRemoveStyle () {
      const cellNames = this.tableauSurface.getHighlighted().map(cell => {
        const x = cell.getAttribute('data-x')
        const y = cell.getAttribute('data-y')
        return jexcel.getColumnNameFromId([x, y])
      })

      const styles = cellNames.reduce((acc, curr) => {
        acc['old'][curr] = this.tableauSurface.getStyle(curr)
        acc['updated'][curr] = 'z-index: auto'
        return acc
      }, { old: {}, updated: {} })

      this.tableauSurface.resetStyle(styles.updated, true)

      this.tableauSurface.setHistory({
        action: 'resetStyle',
        oldValue: styles.old,
        newValue: styles.updated
      })
    },
    handleSetStyle ({ attribut, value }) {
      if (attribut === 'border-outer') {
        const coordX = this.tableauSurface.getHighlighted().map(el => el.getAttribute('data-x'))
        const coordY = this.tableauSurface.getHighlighted().map(el => el.getAttribute('data-y'))
        const minX = Math.min(...coordX)
        const minY = Math.min(...coordY)
        const maxX = Math.max(...coordX)
        const maxY = Math.max(...coordY)

        this.tableauSurface.getHighlighted().forEach(cell => {
          const x = cell.getAttribute('data-x')
          const y = cell.getAttribute('data-y')
          const cellName = jexcel.getColumnNameFromId([x, y])
          let attrValue = ''

          if (parseInt(x, 10) === minX) {
            attrValue = `${attrValue}border-left: ${value};`
          }
          if (parseInt(y, 10) === minY) {
            attrValue = `${attrValue}border-top: ${value};`
          }
          if (parseInt(x, 10) === maxX) {
            attrValue = `${attrValue}border-right: ${value};`
          }
          if (parseInt(y, 10) === maxY) {
            attrValue = `${attrValue}border-bottom: ${value};`
          }
          this.tableauSurface.setStyle({ [cellName]: attrValue })
        })
        return
      }
      if (value) {
        this.tableauSurface.setStyle(this.tableauSurface.getHighlighted(), attribut, `${value}`)
      } else {
        const cellNames = this.tableauSurface.getHighlighted().map(el => {
          const x = el.getAttribute('data-x')
          const y = el.getAttribute('data-y')
          return jexcel.getColumnNameFromId([x, y])
        })

        const update = cellNames.reduce((acc, curr) => {
          acc[curr] = attribut
          return acc
        }, {})

        this.tableauSurface.setStyle(update)
      }
    },
    formatTypedeDonne (typeDonne) {
      const type = Object.keys(typeDonne).map(key => {
        if (typeDonne[key].length > 1) {
          return {
            type: key,
            children: typeDonne[key].map(x => {
              return {
                id: x.id,
                type: x.unite,
                editable: x.editable,
                decimale: x.decimale,
                unite: x.unite
              }
            })
          }
        }

        if (key === 'Format personalisé') {
          return {
            type: key,
            children: [
              {
                id: typeDonne[key][0].id,
                type: typeDonne[key][0].unite,
                editable: typeDonne[key][0].editable,
                decimale: typeDonne[key][0].decimale,
                unite: typeDonne[key][0].unite
              }
            ]
          }
        }

        return {
          type: key,
          id: typeDonne[key][0].id,
          unite: typeDonne[key][0].unite,
          editable: typeDonne[key][0].editable,
          decimale: typeDonne[key][0].decimale
        }
      })
      return type
    },
    getCodeIndex () {
      return this.getColumns().findIndex(col => col.key === 'H0')
    },
    getDenominationIndex () {
      return this.getColumns().findIndex(col => col.key === 'H1')
    },
    setExistingEspace () {
      let espaceAndIndex = []
      let inexistingIndex = []

      this.tableauSurface.getData().forEach((row, index) => {
        if (row[this.codeIndex] !== '' && index !== 0) {
          espaceAndIndex.push({
            index: index,
            row: row
          })
          return
        }
        inexistingIndex.push({
          index: index,
          row: row
        })
      })

      this.existingEspace = [...this.listEspaceForDescription] = espaceAndIndex
      this.inexistingIndex = [...this.listInexistingIndexForDescription] = inexistingIndex
    },
    handleUndo () {
      this.tableauSurface.undo()
    },
    handleRedo () {
      this.tableauSurface.redo()
    },
    handlePaste (el, data) {
      const codeIndex = this.getCodeIndex()
      const rowData = data.filter(row => row.col === codeIndex)
      if (rowData.length > 0) {
        rowData.forEach(element => {
          this.allDescription[element.row].description = ''
          this.tableauSurface.rows[element.row].children[0].children[0].remove()
          this.tableauSurface.rows[element.row].children[0].appendChild(this.createDescription(element.row, 'desc-empty'))
        })
      }
    }
  }
}
</script>

<style lang="scss">
.description-element,
.placeholder-desc {
  position: absolute;
  left: -50px;
  top: 0;
  bottom: -1px;
  z-index: 1004;
  right: 100%;
  align-items: center;
  justify-content: center;
  display: flex;
  background-color: #fff;
  /** use outline, because border dont hide under element on scroll */
  outline: 1px solid #fff;
  border-bottom: 0px solid #fff;
  border-right: 0px solid #fff;
  border-top: 0px solid #fff;
  border-left: 0px solid #fff;
}
.jexcel_content {
  height: calc(100vh - 225px);
  padding-left: 50px;
  width: calc(100vw - 5px);
  overflow: auto;
  .titre-description {
    position: absolute;
    left: -50px;
    top: 0;
    bottom: -1px;
    z-index: 1004;
    right: 100%;
    align-items: center;
    justify-content: center;
    display: flex;
    background-color: #fff;
    /** use outline, because border dont hide under element on scroll */
    outline: 1px solid #fff;
    border-bottom: 0px solid #fff;
    border-right: 0px solid #fff;
    border-top: 0px solid #fff;
    border-left: 0px solid #fff;
  }
  .jexcel_content {
    height: calc(100vh - 225px);
    padding-left: 50px;
    width: calc(100vw - 5px);
    overflow: auto;
    .titre-description {
      position: absolute;
      left: -50px;
      top: 0;
      bottom: -1px;
      z-index: 1003;
      align-items: center;
      justify-content: center;
      display: flex;
      right: 100%;
      color: #fff;
      background-color: #fff;
      border-bottom: 1px solid #fff;
      border-top: 1px solid #fff;
      border-right: 1px solid #fff;
    }
    .hidden_desc {
      position: absolute;
      left: -50px;
      top: 0;
      bottom: -1px;
      z-index: 1004;
      align-items: center;
      justify-content: center;
      display: flex;
      right: 100%;
      background-color: #f8faf2;
      border-bottom: 1px solid #d2e1ea;
      border-top: 1px solid #d2e1ea;
      border-right: 1px solid #d2e1ea;
    }
  }
  .jexcel_pagination {
    display: none;
  }
  .datatype {
    position: fixed;
    z-index: 1002;
    display: flex;
    right: 100%;
    background-color: #f8faf2;
    /** use outline, because border dont hide under element on scroll */
    outline: 1px solid #fff;
    border-bottom: 0px solid #fff;
    border-right: 0px solid #fff;
    border-top: 0px solid #fff;
    border-left: 0px solid #fff;
  }
}
.jexcel_pagination {
  display: none;
}
.datatype {
  position: fixed;
  z-index: 1002;
  display: flex;
  visibility: hidden;
}
.jexcel {
  position: relative;
  z-index: 1000;
  //border-collapse: separate;
  border-collapse: collapse;
  .jexcel_selectall {
    &:before {
      content: "";
      z-index: 1005 !important;
      left: -50px !important;
      top: -1px !important;
      bottom: -1px !important;
      right: calc(100% + 1px);
      width: auto !important;
      height: auto !important;
      background-color: #2b3085;
      border-top: 1px solid #fff;
      border-bottom: 1px solid #fff;
    }
  }
  .jexcel > thead {
    .data-wrapper {
      position: absolute;
      bottom: calc(100% + 2px);
      background: #fff;
      margin-left: -1px;
      left: 0;
      right: 0;
      .element-menu {
        .btn {
          box-shadow: none !important;
          border-radius: 0;
          height: 16px;
        }
      }
      .blank {
        height: 16px;
        display: block;
        &.firstBlank {
          &:before {
            height: 17px;
            content: '';
            width: 99px;
            position: absolute;
            right: 100%;
            background-color: #fff;
          }
        }
      }
      &.not-visible {
        pointer-events: none;
        .btn {
          color: #fff;
        }
      }
    }
  }
  .jexcel > thead > tr > td {
    background-color: #2b3085;
    color: #fff;
    border-bottom: 1px solid transparent;
    border-left: 1px solid #fff;
    border-right: 1px solid transparent;

    box-shadow: none;
    cursor: pointer;
    padding-top: 0px;
    padding-bottom: 0px;
    font-family: "Noto sans", sans-serif;
    font-weight: normal;
    font-size: 14px;
    overflow: unset;
    z-index: 1000;
    &.hidecol {
      border: 2px solid #2b3085 !important;
    }
  }

  .jexcel_selectall {
    position: sticky;
    left: 0;
    z-index: 1004 !important;
    &:after {
      display: none !important;
    }
  }

  .jexcel .freezectnr {
    background-color: #fff;
    box-shadow: 0px 2px 8px -5px rgba(0, 0, 0, 0.75);
    & > tr > td:first-child {
      pointer-events: none;
    }
    & > tr > td {
      vertical-align: middle;
    }
  }
  .jexcel > tbody > tr:first-child > td:first-child {
    pointer-events: auto !important;
    &:after {
      display: none;
      pointer-events: auto;
    }
  }
}
.jexcel > thead > tr > td {
  background-color: #2b3085;
  color: #fff;
  /** use outline, because border dont hide under element on scroll */
  outline: 1px solid #fff;
  border-bottom: 0px solid #fff;
  border-left: 0px solid #fff;
  border-right: 0px solid #fff;
  border-top: 0px solid #fff;

  box-shadow: none;
  cursor: pointer;
  top: -1px; /** fix the one pixel line at the top of the table */
  padding-top: 0px;
  padding-bottom: 0px;
  font-family: "Noto sans", sans-serif;
  font-weight: normal;
  font-size: 14px;
  overflow: unset;
  z-index: 1000;
  &.hidecol {
    border: 2px solid #2b3085 !important;
  }
  .jexcel > tbody > tr > td,
  .jexcel .freezectnr tr > td {
    // box-shadow: inset 0 -1px 0 0 #f2f7fa;
    border-left: 1px solid rgba(43, 48, 133, 0.2);
    border-bottom: 1px solid rgba(43, 48, 133, 0);
    font-family: "Arial";
    font-size: 11px;
    color: #444;
    overflow: hidden;
  }

  .jexcel > tbody > tr > td:first-child,
  .jexcel .freezectnr tr > td:first-child {
    background-color: #2b3085;
    box-shadow: none;
    border-right: 1px solid #fff;
    border-bottom: 1px solid transparent;
    text-align: center;
    padding-top: 0px;
    padding-bottom: 0px;
    cursor: pointer;
    font-family: "Open sans";
    font-size: 14px;
    font-weight: normal;
    position: sticky;
    left: 0;
    overflow: initial;
    line-height: 21px;
    color: #fff;
  }

  .jexcel .freezectnr tr > td:first-child {
    border-bottom: 1px solid #fff;
  }
}
.jexcel .freezectnr tr {
  position: sticky;
}
.jexcel > tbody > tr > td,
.jexcel .freezectnr tr > td {
  border-left: 1px solid rgba(180, 180, 210, 1);
  border-bottom: 1px solid rgba(180, 180, 210, 1);
  border-top: 1px solid rgba(180, 180, 210, 1);
  border-right: 1px solid rgba(180, 180, 210, 1);
  font-family: "Arial";
  font-size: 11px;
  color: #444;
  overflow: hidden;
  padding: 4px;
  white-space: nowrap;
  box-sizing: border-box;
  line-height: 1em;

  &.jexcel_row {
    /** use outline, because border dont hide under element on scroll */
    outline: 1px solid #fff;
    border-left: 0px solid rgba(180, 180, 210, 1);
    border-bottom: 0px solid rgba(180, 180, 210, 1);
    border-top: 0px solid rgba(180, 180, 210, 1);
    border-right: 0px solid rgba(180, 180, 210, 1);
  }
}

.jexcel > tbody > tr > td:first-child,
.jexcel .freezectnr tr > td:first-child {
  background-color: #2b3085;
  box-shadow: none;
  border-right: 1px solid #fff;
  border-bottom: 1px solid #fff;
  border-left: 1px solid #fff;
  border-top: 1px solid #fff;
  text-align: center;
  padding-top: 0px;
  padding-bottom: 0px;
  cursor: pointer;
  font-family: "Open sans";
  font-size: 14px;
  font-weight: normal;
  position: sticky;
  left: 0;
  overflow: initial;
  line-height: 21px;
  color: #fff;
}

.jexcel .freezectnr tr > td:first-child {
  //border-bottom: 1px solid #fff;
}

.jexcel > tbody > tr.hideRow td {
  height: 1px;
  padding: 0px;
  overflow: hidden;
  line-height: 0;
  // box-shadow: inset 0 -2px 0 0 #2b3085, 3px 0 2px 0 rgba(0, 0, 0, 0.1);
  color: transparent;
  box-shadow: none;

  &.jexcel_row {
    //border: 1px solid #2b3085 !important;
  }

  .jexcel_contextmenu {
    background-color: #fff;
    box-shadow: 0 9px 15px 0 rgba(0, 0, 0, 0.1);

    ul.jcontextmenu {
      list-style: none;
      padding-left: 0;
      min-width: 200px;
      margin-bottom: 0;

      li {
        padding-left: 10px;
        padding-right: 10px;
        padding-top: 0;
        padding-bottom: 0;
        height: 25px;

        &:hover {
          background-color: #f2f7fa;
        }

        a,
        span {
          font-size: 12px;
          color: #2b3085;
          line-height: 25px;
          font-family: "Noto Sans";
          text-decoration: none;
        }
      }
    }
  }

  .freezedCol {
    position: sticky;
    // z-index: 1001 !important;
    background-color: #fff;

    &.header-col {
      pointer-events: none;
    }

    &.last-col {
      overflow: initial;

      &:after {
        content: "";
        width: 3px;
        position: absolute;
        right: 0;
        top: -1px;
        bottom: -1px;
        box-shadow: 2px 0px 3px -1px rgba(0, 0, 0, 0.75);
        z-index: -1 !important;
      }
    }
  }

  .inner-test {
    width: 50px;
    height: 50px;
    background-color: yellow;
  }

  #espaceDescription {
    .modal-body {
      height: calc(100vh - 100px);
      overflow-y: auto;
      overflow-x: hidden;
    }

    .ck-editor__editable {
      max-height: calc(100vh - 360px);
    }
  }

  #espaceDescriptionExport {
    ul {
      list-style: none;
    }
  }

  .ck.ck-balloon-panel.ck-balloon-panel_visible {
    z-index: 99999;
  }

  .ck-content .table {
    table {
      width: 100%;
    }
  }

  .description-element {
    cursor: pointer;

    svg.desc-empty {
      color: #dedede;
    }

    svg.desc-full {
      color: #f9b11c;
    }
  }

  .list-description-area {
    height: calc(100vh - 320px);
    // margin-right: -15px;
    // padding-right: 15px;
    .ps__thumb-x,
    .ps__thumb-y {
      background-color: #2b3085 !important;
      width: 6px !important;
      right: 0;

      &:hover {
        background-color: #2b3085;
        width: 6px;
      }
    }

    .ps__rail-y {
      display: block;
      width: 8px;
      border: 1px solid #2b3085;
      border-radius: 6px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/tableau/tableauInvite.vue